// Localized replacements for legacy English fallback strings.
// Technical identifiers and interpolation placeholders are intentionally preserved.
const legacyCompletion = {
  "en": {},
  "ko": {},
  "ru": {
    "%) 중 몇 %를 하위에게 분배하시겠습니까?": "%) — какой процент распределить нижестоящему?",
    "(여기 클릭하면 새 공지 모달 오픈)": "(Нажмите здесь, чтобы открыть окно нового объявления)",
    "* index를 바꾼 뒤": "* После изменения index",
    "* 무한 모드일 때 UI상 “30일마다 갱신”로 표시용": "* В бесконечном режиме отображается как «обновляется каждые 30 дней»",
    "* 예: 상위 50% 중": "* Пример: из верхних 50%",
    "* 이 설정은 인포카드 내부 카운트다운 기준입니다. 위 시간 설정은 로비 노출 기간만 제어합니다.": "* Эта настройка задаёт обратный отсчёт внутри инфокарточки. Параметры времени выше управляют только периодом показа в лобби.",
    "* 이 스타일은 인포카드의 text 요소에만 적용됩니다. 타이머/아이콘은 기존 스타일을 유지합니다.": "* Этот стиль применяется только к элементам text инфокарточки. Таймер и значки сохраняют текущий стиль.",
    "* 이 시간에 “유효한(display_sets.time)” 그룹만 아래 목록에 표시": "* Ниже показаны только группы, действующие в это время (display_sets.time)",
    "* 저장은 UTC로 들어가고, 화면은 로컬 시간으로 입력/표시됨": "* Сохраняется в UTC, а ввод и показ на экране выполняются по локальному времени",
    "* 필요할 때만 추가하면 됨": "* Добавляйте только при необходимости",
    "* 현재 기준시간 주변(±15~45일)에 기간(range) 설정된 DisplaySet이 없습니다.": "* Вблизи текущего времени (±15–45 дней) нет DisplaySet с заданным периодом (range).",
    "+ 타이머(표시여부)": "+ Таймер (показывать или нет)",
    "- PENDING 는 저장만 되고 노출되지 않음": "- PENDING только сохраняется и не показывается",
    "- SCHEDULED 는 startAt 이후 자동 노출": "- SCHEDULED автоматически показывается после startAt",
    "- endAt 이 지나면 자동 만료": "- После endAt автоматически истекает",
    "/community/notice/1 또는 https://...": "/community/notice/1 или https://...",
    "Due Date 지정": "Указать срок",
    "Due Date(관리자 로컬 시간)": "Срок (локальное время администратора)",
    "RUN 생성: 미션 총 베팅금(target_total_bet) 입력": "Создать RUN: введите общий объём ставок миссии (target_total_bet)",
    "RUN 생성: 테이블 미션 총 베팅금(target_total_bet) 입력": "Создать RUN: введите общий объём ставок миссии стола (target_total_bet)",
    "endAt (종료, 선택)": "endAt (завершение, необязательно)",
    "index(선택)": "index (необязательно)",
    "reserve_time_utc(표시:로컬)": "reserve_time_utc (показ: локальное время)",
    "reserve_time_utc가 지난 waiting들을 running으로 전환": "Перевести waiting с прошедшим reserve_time_utc в running",
    "startAt (시작)": "startAt (начало)",
    "status(선택)": "status (необязательно)",
    "superadmin 전용 UI (admin-server / DB 저장)": "Интерфейс только для суперадминистратора (admin-server / сохранение в БД)",
    "tick 실패": "Ошибка tick",
    "{targetId} 삭제하시겠습니까?": "Удалить {targetId}?",
    "※ 이미지는 admin server 의": "※ Изображения хранятся на admin server в",
    "※ 입력이 없으면 0%로 처리됩니다.": "※ Если не указано, используется 0%.",
    "※ 입력이 없으면 0.00%로 처리됩니다.": "※ Если не указано, используется 0,00%.",
    "※ 현재 저장은 admin-server API를 통해 DB에 반영됨.": "※ Текущие данные сохраняются в БД через API admin-server.",
    "→ 하위는": "→ Нижестоящий получает",
    "같은 area라도 device/country가 다르면 각각 별도 row로 저장돼.": "Даже при одинаковом area разные device/country сохраняются отдельными строками.",
    "갱신 중": "Обновление",
    "공지 목록 불러오는 중...": "Загрузка списка объявлений...",
    "공지 목록을 불러오지 못했어.\n{message}": "Не удалось загрузить список объявлений.\n{message}",
    "공지 삭제에 실패했어.\n{message}": "Не удалось удалить объявление.\n{message}",
    "공지 삭제할까?\n\n- {title}": "Удалить объявление?\n\n- {title}",
    "공지 저장에 실패했어.\n{message}": "Не удалось сохранить объявление.\n{message}",
    "광고 목록 불러오는 중...": "Загрузка списка рекламы...",
    "광고를 삭제할까?\n\n- {label}": "Удалить рекламу?\n\n- {label}",
    "그룹 미션 RUN 중지?\nrun_id={runId}": "Остановить RUN групповой миссии?\nrun_id={runId}",
    "그룹 미션 중지 실패 (백엔드에 DELETE /admin/mission/run/:run_id 필요)": "Не удалось остановить групповую миссию (в бэкенде требуется DELETE /admin/mission/run/:run_id)",
    "그룹은 삭제됐지만 Redis 정리가 실패했습니다. (code={code})": "Группа удалена, но очистка Redis не выполнена. (code={code})",
    "링크는 http:// 또는 https:// 로 시작해야 해.": "Ссылка должна начинаться с http:// или https://.",
    "미션 총 베팅금(target_total_bet)을 입력": "Введите общий объём ставок миссии (target_total_bet)",
    "미입력시 자동": "Автоматически, если не указано",
    "백엔드에 종료 API가 있어야 실제 중지됨": "Для фактической остановки в бэкенде должен быть API завершения",
    "비워두면 클릭 이동 없음": "Если оставить пустым, переход по клику отключён",
    "상단 고정(📌)": "Закрепить сверху (📌)",
    "상위 에이전트의 수수료(": "Комиссия вышестоящего агента (",
    "상태 보기 (테이블 미션 raw)": "Показать состояние (raw миссии стола)",
    "생성 에러:": "Ошибка создания:",
    "수정(설정)": "Изменить (настройки)",
    "시작(생성)": "Начать (создать)",
    "아이디": "ID",
    "아이콘 업로드 실패 (서버 업로드 API 확인 필요)": "Не удалось загрузить значок (проверьте API загрузки сервера)",
    "아이콘(로컬 업로드/URL)": "Значок (локальная загрузка/URL)",
    "업로드하면 /uploads/... 로 자동 입력됨 (또는 URL 직접 입력)": "После загрузки автоматически подставляется /uploads/... (или введите URL вручную)",
    "에이전트 분배 비율(agent_share) 입력 (예: 0.2 = 20%)": "Введите долю агента (agent_share), например 0.2 = 20%",
    "예: HOT": "Пример: HOT",
    "예: KR / US / JP / ALL": "Пример: KR / US / JP / ALL",
    "예: NEW YEAR EVENT START!": "Пример: NEW YEAR EVENT START!",
    "예: VIP NLH 1/2": "Пример: VIP NLH 1/2",
    "예: 메인 KR 모바일 상단 배너": "Пример: главный верхний мобильный баннер KR",
    "예: 오늘만 레이크 0%": "Пример: только сегодня рейк 0%",
    "예: 🔥 12/31 이벤트 진행중": "Пример: 🔥 Событие 12/31 продолжается",
    "예: 🔧HOT": "Пример: 🔧HOT",
    "예약 tick": "Запланированный tick",
    "예약 보류": "Отложить расписание",
    "예약 사용": "Использовать расписание",
    "예약 상태면 startAt(시작일시)를 넣어줘.": "Для запланированного состояния укажите startAt (время начала).",
    "예약 없음 → 즉시 진행(running)으로 자동 설정됨": "Без расписания → автоматически сразу running",
    "예약(reserve_time_utc)": "Расписание (reserve_time_utc)",
    "예약보류": "Отложено по расписанию",
    "왼쪽에서 공지를 선택해줘.": "Выберите объявление слева.",
    "왼쪽에서 광고를 선택해줘.": "Выберите рекламу слева.",
    "을 눌러야 서버에 반영됨": "Чтобы применить на сервере, нажмите",
    "이메일": "Электронная почта",
    "이미 테이블 미션 RUN이 실행 중입니다.\n(run_id={runId})\n재시작(기존 RUN 삭제 후 새로 생성)할까요?": "RUN миссии стола уже выполняется.\n(run_id={runId})\nПерезапустить, удалив старый RUN и создав новый?",
    "이미지 넣기": "Добавить изображение",
    "이미지는 본문 안에 [image-번호] 형태로 표시됨.": "Изображение отображается в тексте как [image-номер].",
    "인포 버튼 프리셋 수정 실패": "Не удалось изменить пресет информационной кнопки",
    "인포버튼 프리셋 수정 실패": "Не удалось изменить пресет инфокнопки",
    "인포카드 추가 실패": "Не удалось добавить инфокарточку",
    "잠금 비밀번호": "Пароль блокировки",
    "저장 시 실제 이미지 URL 토큰으로 자동 변환됨.": "При сохранении автоматически преобразуется в реальный токен URL изображения.",
    "저장됩니다. 기준 시간은 위 인포카드 타이머 설정(timerMode/timerEndUtc)을 사용합니다.": "Будет сохранено. За базовое время берётся настройка таймера инфокарточки выше (timerMode/timerEndUtc).",
    "전광판": "Информационное табло",
    "전광판 삭제?\n(id={id})": "Удалить табло?\n(id={id})",
    "정렬 화살표는 같은 area/device/country 묶음 안에서만 동작해.": "Стрелки сортировки работают только внутри одной группы area/device/country.",
    "줄바꿈 그대로 표시됨.": "Переносы строк сохраняются.",
    "중지(삭제)": "Остановить (удалить)",
    "체크하지 않으면 앞으로 새로 생성되는 테이블에만 적용됩니다.": "Если флажок не установлен, применяется только к новым столам.",
    "추가": "Добавить",
    "테이블 그룹 삭제?\n({displayCode})": "Удалить группу столов?\n({displayCode})",
    "테이블 미션 RUN 중지(그룹 전체 적용)?\n(display_code={displayCode})": "Остановить RUN миссии стола для всей группы?\n(display_code={displayCode})",
    "테이블 미션 에이전트 분배 비율(agent_share) 입력 (예: 0.2 = 20%)": "Введите долю агента миссии стола (agent_share), например 0.2 = 20%",
    "테이블 미션 총 베팅금(target_total_bet)을 입력": "Введите общий объём ставок миссии стола (target_total_bet)",
    "폴더에 저장되고, DB에는 메타/경로만 저장돼.": "Сохраняется в папке; в БД сохраняются только метаданные и путь.",
    "현재 index 값들을 서버에 저장": "Сохранить текущие значения index на сервере",
    "현재 활성 테이블에도 즉시 적용": "Немедленно применить к активным столам"
  },
  "zh": {
    "%) 중 몇 %를 하위에게 분배하시겠습니까?": "%) 中要向下级分配多少百分比？",
    "(여기 클릭하면 새 공지 모달 오픈)": "（点击此处打开新公告弹窗）",
    "* index를 바꾼 뒤": "* 更改 index 后",
    "* 무한 모드일 때 UI상 “30일마다 갱신”로 표시용": "* 无限模式下，UI 显示为“每 30 天更新”",
    "* 예: 상위 50% 중": "* 示例：上级 50% 中",
    "* 이 설정은 인포카드 내부 카운트다운 기준입니다. 위 시간 설정은 로비 노출 기간만 제어합니다.": "* 此设置是信息卡内部倒计时的基准。上方时间设置仅控制大厅展示期间。",
    "* 이 스타일은 인포카드의 text 요소에만 적용됩니다. 타이머/아이콘은 기존 스타일을 유지합니다.": "* 此样式仅应用于信息卡的 text 元素。计时器和图标保留现有样式。",
    "* 이 시간에 “유효한(display_sets.time)” 그룹만 아래 목록에 표시": "* 下方列表仅显示此时有效的（display_sets.time）组",
    "* 저장은 UTC로 들어가고, 화면은 로컬 시간으로 입력/표시됨": "* 以 UTC 保存，画面按本地时间输入和显示",
    "* 필요할 때만 추가하면 됨": "* 仅在需要时添加",
    "* 현재 기준시간 주변(±15~45일)에 기간(range) 설정된 DisplaySet이 없습니다.": "* 当前基准时间附近（±15～45 天）没有设置期间（range）的 DisplaySet。",
    "+ 타이머(표시여부)": "+ 计时器（是否显示）",
    "- PENDING 는 저장만 되고 노출되지 않음": "- PENDING 仅保存，不展示",
    "- SCHEDULED 는 startAt 이후 자동 노출": "- SCHEDULED 在 startAt 后自动展示",
    "- endAt 이 지나면 자동 만료": "- 超过 endAt 后自动过期",
    "/community/notice/1 또는 https://...": "/community/notice/1 或 https://...",
    "Due Date 지정": "指定截止日期",
    "Due Date(관리자 로컬 시간)": "截止日期（管理员本地时间）",
    "RUN 생성: 미션 총 베팅금(target_total_bet) 입력": "创建 RUN：输入任务总投注额（target_total_bet）",
    "RUN 생성: 테이블 미션 총 베팅금(target_total_bet) 입력": "创建 RUN：输入牌桌任务总投注额（target_total_bet）",
    "endAt (종료, 선택)": "endAt（结束，可选）",
    "index(선택)": "index（可选）",
    "reserve_time_utc(표시:로컬)": "reserve_time_utc（显示：本地时间）",
    "reserve_time_utc가 지난 waiting들을 running으로 전환": "将超过 reserve_time_utc 的 waiting 转为 running",
    "startAt (시작)": "startAt（开始）",
    "status(선택)": "status（可选）",
    "superadmin 전용 UI (admin-server / DB 저장)": "仅限超级管理员的 UI（admin-server / DB 保存）",
    "tick 실패": "tick 失败",
    "{targetId} 삭제하시겠습니까?": "是否删除 {targetId}？",
    "※ 이미지는 admin server 의": "※ 图片存储于 admin server 的",
    "※ 입력이 없으면 0%로 처리됩니다.": "※ 未输入时按 0% 处理。",
    "※ 입력이 없으면 0.00%로 처리됩니다.": "※ 未输入时按 0.00% 处理。",
    "※ 현재 저장은 admin-server API를 통해 DB에 반영됨.": "※ 当前保存内容通过 admin-server API 写入 DB。",
    "→ 하위는": "→ 下级获得",
    "같은 area라도 device/country가 다르면 각각 별도 row로 저장돼.": "即使 area 相同，device/country 不同也会分别保存为独立 row。",
    "갱신 중": "更新中",
    "공지 목록 불러오는 중...": "正在加载公告列表...",
    "공지 목록을 불러오지 못했어.\n{message}": "无法加载公告列表。\n{message}",
    "공지 삭제에 실패했어.\n{message}": "删除公告失败。\n{message}",
    "공지 삭제할까?\n\n- {title}": "是否删除公告？\n\n- {title}",
    "공지 저장에 실패했어.\n{message}": "保存公告失败。\n{message}",
    "광고 목록 불러오는 중...": "正在加载广告列表...",
    "광고를 삭제할까?\n\n- {label}": "是否删除广告？\n\n- {label}",
    "그룹 미션 RUN 중지?\nrun_id={runId}": "是否停止组任务 RUN？\nrun_id={runId}",
    "그룹 미션 중지 실패 (백엔드에 DELETE /admin/mission/run/:run_id 필요)": "停止组任务失败（后端需要 DELETE /admin/mission/run/:run_id）",
    "그룹은 삭제됐지만 Redis 정리가 실패했습니다. (code={code})": "组已删除，但 Redis 清理失败。（code={code}）",
    "링크는 http:// 또는 https:// 로 시작해야 해.": "链接必须以 http:// 或 https:// 开头。",
    "미션 총 베팅금(target_total_bet)을 입력": "输入任务总投注额（target_total_bet）",
    "미입력시 자동": "未输入时自动",
    "백엔드에 종료 API가 있어야 실제 중지됨": "后端必须提供结束 API 才能真正停止",
    "비워두면 클릭 이동 없음": "留空则点击不跳转",
    "상단 고정(📌)": "置顶（📌）",
    "상위 에이전트의 수수료(": "上级代理的手续费（",
    "상태 보기 (테이블 미션 raw)": "查看状态（牌桌任务 raw）",
    "생성 에러:": "创建错误：",
    "수정(설정)": "修改（设置）",
    "시작(생성)": "开始（创建）",
    "아이디": "ID",
    "아이콘 업로드 실패 (서버 업로드 API 확인 필요)": "图标上传失败（请检查服务器上传 API）",
    "아이콘(로컬 업로드/URL)": "图标（本地上传/URL）",
    "업로드하면 /uploads/... 로 자동 입력됨 (또는 URL 직접 입력)": "上传后自动填入 /uploads/...（或直接输入 URL）",
    "에이전트 분배 비율(agent_share) 입력 (예: 0.2 = 20%)": "输入代理分配比例（agent_share）（例如：0.2 = 20%）",
    "예: HOT": "示例：HOT",
    "예: KR / US / JP / ALL": "示例：KR / US / JP / ALL",
    "예: NEW YEAR EVENT START!": "示例：NEW YEAR EVENT START!",
    "예: VIP NLH 1/2": "示例：VIP NLH 1/2",
    "예: 메인 KR 모바일 상단 배너": "示例：主 KR 移动端顶部横幅",
    "예: 오늘만 레이크 0%": "示例：仅今天 Rake 0%",
    "예: 🔥 12/31 이벤트 진행중": "示例：🔥 12/31 活动进行中",
    "예: 🔧HOT": "示例：🔧HOT",
    "예약 tick": "预约 tick",
    "예약 보류": "预约保留",
    "예약 사용": "启用预约",
    "예약 상태면 startAt(시작일시)를 넣어줘.": "预约状态时请输入 startAt（开始时间）。",
    "예약 없음 → 즉시 진행(running)으로 자동 설정됨": "无预约 → 自动立即设为 running",
    "예약(reserve_time_utc)": "预约（reserve_time_utc）",
    "예약보류": "预约保留",
    "왼쪽에서 공지를 선택해줘.": "请从左侧选择公告。",
    "왼쪽에서 광고를 선택해줘.": "请从左侧选择广告。",
    "을 눌러야 서버에 반영됨": "必须按下后才会应用到服务器",
    "이미 테이블 미션 RUN이 실행 중입니다.\n(run_id={runId})\n재시작(기존 RUN 삭제 후 새로 생성)할까요?": "牌桌任务 RUN 已在执行。\n（run_id={runId}）\n是否重启（删除现有 RUN 后重新创建）？",
    "이미지 넣기": "添加图片",
    "이미지는 본문 안에 [image-번호] 형태로 표시됨.": "图片会在正文中以 [image-编号] 形式显示。",
    "인포 버튼 프리셋 수정 실패": "修改信息按钮预设失败",
    "인포버튼 프리셋 수정 실패": "修改信息按钮预设失败",
    "인포카드 추가 실패": "添加信息卡失败",
    "잠금 비밀번호": "锁定密码",
    "저장 시 실제 이미지 URL 토큰으로 자동 변환됨.": "保存时会自动转换为实际图片 URL 令牌。",
    "저장됩니다. 기준 시간은 위 인포카드 타이머 설정(timerMode/timerEndUtc)을 사용합니다.": "将被保存。基准时间使用上方信息卡计时器设置（timerMode/timerEndUtc）。",
    "전광판": "电子公告牌",
    "전광판 삭제?\n(id={id})": "是否删除电子公告牌？\n（id={id}）",
    "정렬 화살표는 같은 area/device/country 묶음 안에서만 동작해.": "排序箭头仅在同一 area/device/country 组内有效。",
    "줄바꿈 그대로 표시됨.": "按原换行显示。",
    "중지(삭제)": "停止（删除）",
    "체크하지 않으면 앞으로 새로 생성되는 테이블에만 적용됩니다.": "若不勾选，只会应用于之后新建的牌桌。",
    "추가": "添加",
    "테이블 그룹 삭제?\n({displayCode})": "是否删除牌桌组？\n（{displayCode}）",
    "테이블 미션 RUN 중지(그룹 전체 적용)?\n(display_code={displayCode})": "是否停止牌桌任务 RUN（应用于整个组）？\n（display_code={displayCode}）",
    "테이블 미션 에이전트 분배 비율(agent_share) 입력 (예: 0.2 = 20%)": "输入牌桌任务代理分配比例（agent_share）（例如：0.2 = 20%）",
    "테이블 미션 총 베팅금(target_total_bet)을 입력": "输入牌桌任务总投注额（target_total_bet）",
    "폴더에 저장되고, DB에는 메타/경로만 저장돼.": "保存到文件夹，DB 中仅保存元数据和路径。",
    "현재 index 값들을 서버에 저장": "将当前 index 值保存到服务器",
    "현재 활성 테이블에도 즉시 적용": "立即应用于当前活动牌桌"
  },
  "vi": {
    "%) 중 몇 %를 하위에게 분배하시겠습니까?": "%) muốn phân phối bao nhiêu % cho cấp dưới?",
    "(여기 클릭하면 새 공지 모달 오픈)": "(Nhấp vào đây để mở cửa sổ thông báo mới)",
    "* index를 바꾼 뒤": "* Sau khi thay đổi index",
    "* 무한 모드일 때 UI상 “30일마다 갱신”로 표시용": "* Ở chế độ vô hạn, UI hiển thị là ‘cập nhật mỗi 30 ngày’",
    "* 예: 상위 50% 중": "* Ví dụ: trong 50% của cấp trên",
    "* 이 설정은 인포카드 내부 카운트다운 기준입니다. 위 시간 설정은 로비 노출 기간만 제어합니다.": "* Cài đặt này là mốc đếm ngược bên trong thẻ thông tin. Cài đặt thời gian phía trên chỉ điều khiển thời gian hiển thị ở sảnh.",
    "* 이 스타일은 인포카드의 text 요소에만 적용됩니다. 타이머/아이콘은 기존 스타일을 유지합니다.": "* Kiểu này chỉ áp dụng cho phần tử text của thẻ thông tin. Bộ đếm giờ và biểu tượng giữ nguyên kiểu hiện tại.",
    "* 이 시간에 “유효한(display_sets.time)” 그룹만 아래 목록에 표시": "* Chỉ hiển thị các nhóm hợp lệ tại thời điểm này (display_sets.time) trong danh sách dưới",
    "* 저장은 UTC로 들어가고, 화면은 로컬 시간으로 입력/표시됨": "* Lưu theo UTC, nhập và hiển thị trên màn hình theo giờ địa phương",
    "* 필요할 때만 추가하면 됨": "* Chỉ thêm khi cần",
    "* 현재 기준시간 주변(±15~45일)에 기간(range) 설정된 DisplaySet이 없습니다.": "* Không có DisplaySet đặt thời gian (range) quanh thời điểm hiện tại (±15–45 ngày).",
    "+ 타이머(표시여부)": "+ Bộ đếm giờ (hiển thị hay không)",
    "- PENDING 는 저장만 되고 노출되지 않음": "- PENDING chỉ được lưu và không hiển thị",
    "- SCHEDULED 는 startAt 이후 자동 노출": "- SCHEDULED tự động hiển thị sau startAt",
    "- endAt 이 지나면 자동 만료": "- Tự động hết hạn sau endAt",
    "/community/notice/1 또는 https://...": "/community/notice/1 hoặc https://...",
    "Due Date 지정": "Chỉ định Due Date",
    "Due Date(관리자 로컬 시간)": "Due Date (giờ địa phương của quản trị viên)",
    "RUN 생성: 미션 총 베팅금(target_total_bet) 입력": "Tạo RUN: nhập tổng tiền cược nhiệm vụ (target_total_bet)",
    "RUN 생성: 테이블 미션 총 베팅금(target_total_bet) 입력": "Tạo RUN: nhập tổng tiền cược nhiệm vụ bàn (target_total_bet)",
    "USDT TRC20 테스트넷": "Mạng thử nghiệm USDT TRC20",
    "endAt (종료, 선택)": "endAt (kết thúc, tùy chọn)",
    "index(선택)": "index (tùy chọn)",
    "reserve_time_utc(표시:로컬)": "reserve_time_utc (hiển thị: địa phương)",
    "reserve_time_utc가 지난 waiting들을 running으로 전환": "Chuyển các mục waiting đã qua reserve_time_utc sang running",
    "startAt (시작)": "startAt (bắt đầu)",
    "status(선택)": "status (tùy chọn)",
    "superadmin 전용 UI (admin-server / DB 저장)": "UI chỉ dành cho superadmin (admin-server / lưu DB)",
    "tick 실패": "tick thất bại",
    "{targetId} 삭제하시겠습니까?": "Xóa {targetId}?",
    "※ 이미지는 admin server 의": "※ Hình ảnh nằm trong admin server tại",
    "※ 입력이 없으면 0%로 처리됩니다.": "※ Nếu không nhập sẽ xử lý là 0%.",
    "※ 입력이 없으면 0.00%로 처리됩니다.": "※ Nếu không nhập sẽ xử lý là 0.00%.",
    "※ 현재 저장은 admin-server API를 통해 DB에 반영됨.": "※ Dữ liệu hiện tại được lưu vào DB qua API admin-server.",
    "→ 하위는": "→ Cấp dưới nhận",
    "같은 area라도 device/country가 다르면 각각 별도 row로 저장돼.": "Dù cùng area, device/country khác nhau sẽ được lưu thành từng row riêng.",
    "갱신 중": "Đang cập nhật",
    "공지 목록 불러오는 중...": "Đang tải danh sách thông báo...",
    "공지 목록을 불러오지 못했어.\n{message}": "Không thể tải danh sách thông báo.\n{message}",
    "공지 삭제에 실패했어.\n{message}": "Xóa thông báo thất bại.\n{message}",
    "공지 삭제할까?\n\n- {title}": "Xóa thông báo?\n\n- {title}",
    "공지 저장에 실패했어.\n{message}": "Lưu thông báo thất bại.\n{message}",
    "광고 목록 불러오는 중...": "Đang tải danh sách quảng cáo...",
    "광고를 삭제할까?\n\n- {label}": "Xóa quảng cáo?\n\n- {label}",
    "그룹 미션 RUN 중지?\nrun_id={runId}": "Dừng RUN nhiệm vụ nhóm?\nrun_id={runId}",
    "그룹 미션 중지 실패 (백엔드에 DELETE /admin/mission/run/:run_id 필요)": "Dừng nhiệm vụ nhóm thất bại (backend cần DELETE /admin/mission/run/:run_id)",
    "그룹은 삭제됐지만 Redis 정리가 실패했습니다. (code={code})": "Nhóm đã bị xóa nhưng dọn Redis thất bại. (code={code})",
    "라운지 포인트 %": "Điểm sảnh %",
    "라운지 포인트 % (0~100)": "Điểm sảnh % (0~100)",
    "레이크백": "Hoàn rake",
    "링크는 http:// 또는 https:// 로 시작해야 해.": "Liên kết phải bắt đầu bằng http:// hoặc https://.",
    "미션 총 베팅금(target_total_bet)을 입력": "Nhập tổng tiền cược nhiệm vụ (target_total_bet)",
    "미입력시 자동": "Tự động nếu để trống",
    "백엔드에 종료 API가 있어야 실제 중지됨": "Backend phải có API kết thúc thì mới dừng thực sự",
    "비워두면 클릭 이동 없음": "Để trống thì nhấp không chuyển trang",
    "상단 고정(📌)": "Ghim trên cùng (📌)",
    "상위 에이전트의 수수료(": "Phí của đại lý cấp trên (",
    "상태 보기 (테이블 미션 raw)": "Xem trạng thái (raw nhiệm vụ bàn)",
    "생성 에러:": "Lỗi tạo:",
    "수정(설정)": "Sửa (cài đặt)",
    "시작(생성)": "Bắt đầu (tạo)",
    "아이디": "ID",
    "아이콘 업로드 실패 (서버 업로드 API 확인 필요)": "Tải biểu tượng thất bại (kiểm tra API tải lên của máy chủ)",
    "아이콘(로컬 업로드/URL)": "Biểu tượng (tải cục bộ/URL)",
    "업로드하면 /uploads/... 로 자동 입력됨 (또는 URL 직접 입력)": "Sau khi tải lên sẽ tự điền /uploads/... (hoặc nhập URL trực tiếp)",
    "에이전트 분배 비율(agent_share) 입력 (예: 0.2 = 20%)": "Nhập tỷ lệ phân phối đại lý (agent_share), ví dụ 0.2 = 20%",
    "예: HOT": "Ví dụ: HOT",
    "예: KR / US / JP / ALL": "Ví dụ: KR / US / JP / ALL",
    "예: NEW YEAR EVENT START!": "Ví dụ: NEW YEAR EVENT START!",
    "예: VIP NLH 1/2": "Ví dụ: VIP NLH 1/2",
    "예: 메인 KR 모바일 상단 배너": "Ví dụ: banner trên cùng mobile KR chính",
    "예: 오늘만 레이크 0%": "Ví dụ: chỉ hôm nay rake 0%",
    "예: 🔥 12/31 이벤트 진행중": "Ví dụ: 🔥 sự kiện 12/31 đang diễn ra",
    "예: 🔧HOT": "Ví dụ: 🔧HOT",
    "예약 tick": "tick theo lịch",
    "예약 보류": "Tạm hoãn lịch",
    "예약 사용": "Dùng lịch",
    "예약 상태면 startAt(시작일시)를 넣어줘.": "Nếu ở trạng thái đặt lịch, hãy nhập startAt (thời gian bắt đầu).",
    "예약 없음 → 즉시 진행(running)으로 자동 설정됨": "Không có lịch → tự động chuyển ngay sang running",
    "예약(reserve_time_utc)": "Đặt lịch (reserve_time_utc)",
    "예약보류": "Đang hoãn lịch",
    "왼쪽에서 공지를 선택해줘.": "Chọn thông báo ở bên trái.",
    "왼쪽에서 광고를 선택해줘.": "Chọn quảng cáo ở bên trái.",
    "을 눌러야 서버에 반영됨": "Phải nhấn thì mới áp dụng lên máy chủ",
    "이메일": "Email",
    "이미 테이블 미션 RUN이 실행 중입니다.\n(run_id={runId})\n재시작(기존 RUN 삭제 후 새로 생성)할까요?": "RUN nhiệm vụ bàn đang chạy.\n(run_id={runId})\nKhởi động lại bằng cách xóa RUN cũ và tạo RUN mới?",
    "이미지 넣기": "Thêm hình ảnh",
    "이미지는 본문 안에 [image-번호] 형태로 표시됨.": "Hình ảnh được hiển thị trong nội dung theo dạng [image-số].",
    "인포 버튼 프리셋 수정 실패": "Sửa preset nút thông tin thất bại",
    "인포버튼 프리셋 수정 실패": "Sửa preset nút info thất bại",
    "인포카드 추가 실패": "Thêm thẻ thông tin thất bại",
    "잠금 비밀번호": "Mật khẩu khóa",
    "저장 시 실제 이미지 URL 토큰으로 자동 변환됨.": "Khi lưu sẽ tự chuyển thành token URL hình ảnh thực tế.",
    "저장됩니다. 기준 시간은 위 인포카드 타이머 설정(timerMode/timerEndUtc)을 사용합니다.": "Sẽ được lưu. Thời gian chuẩn dùng cài đặt bộ đếm giờ thẻ thông tin phía trên (timerMode/timerEndUtc).",
    "전광판": "Bảng điện tử",
    "전광판 삭제?\n(id={id})": "Xóa bảng điện tử?\n(id={id})",
    "정렬 화살표는 같은 area/device/country 묶음 안에서만 동작해.": "Mũi tên sắp xếp chỉ hoạt động trong cùng nhóm area/device/country.",
    "줄바꿈 그대로 표시됨.": "Hiển thị nguyên dấu xuống dòng.",
    "중지(삭제)": "Dừng (xóa)",
    "체크하지 않으면 앞으로 새로 생성되는 테이블에만 적용됩니다.": "Nếu không chọn, chỉ áp dụng cho các bàn mới được tạo sau này.",
    "추가": "Thêm",
    "테이블 그룹 삭제?\n({displayCode})": "Xóa nhóm bàn?\n({displayCode})",
    "테이블 미션 RUN 중지(그룹 전체 적용)?\n(display_code={displayCode})": "Dừng RUN nhiệm vụ bàn cho toàn nhóm?\n(display_code={displayCode})",
    "테이블 미션 에이전트 분배 비율(agent_share) 입력 (예: 0.2 = 20%)": "Nhập tỷ lệ phân phối đại lý của nhiệm vụ bàn (agent_share), ví dụ 0.2 = 20%",
    "테이블 미션 총 베팅금(target_total_bet)을 입력": "Nhập tổng tiền cược nhiệm vụ bàn (target_total_bet)",
    "폴더에 저장되고, DB에는 메타/경로만 저장돼.": "Lưu trong thư mục; DB chỉ lưu metadata và đường dẫn.",
    "현재 index 값들을 서버에 저장": "Lưu các giá trị index hiện tại lên máy chủ",
    "현재 활성 테이블에도 즉시 적용": "Áp dụng ngay cho các bàn đang hoạt động"
  },
  "th": {
    "%) 중 몇 %를 하위에게 분배하시겠습니까?": "%) ต้องการแบ่งให้ระดับล่างกี่เปอร์เซ็นต์?",
    "(여기 클릭하면 새 공지 모달 오픈)": "(คลิกที่นี่เพื่อเปิดหน้าต่างประกาศใหม่)",
    "* index를 바꾼 뒤": "* หลังเปลี่ยน index",
    "* 무한 모드일 때 UI상 “30일마다 갱신”로 표시용": "* ในโหมดไม่สิ้นสุด UI จะแสดงว่า ‘อัปเดตทุก 30 วัน’",
    "* 예: 상위 50% 중": "* ตัวอย่าง: จาก 50% ของระดับบน",
    "* 이 설정은 인포카드 내부 카운트다운 기준입니다. 위 시간 설정은 로비 노출 기간만 제어합니다.": "* การตั้งค่านี้เป็นเกณฑ์นับถอยหลังภายในการ์ดข้อมูล การตั้งค่าเวลาด้านบนควบคุมเฉพาะช่วงแสดงในล็อบบี้",
    "* 이 스타일은 인포카드의 text 요소에만 적용됩니다. 타이머/아이콘은 기존 스타일을 유지합니다.": "* สไตล์นี้ใช้เฉพาะองค์ประกอบ text ของการ์ดข้อมูล ตัวจับเวลาและไอคอนใช้สไตล์เดิม",
    "* 이 시간에 “유효한(display_sets.time)” 그룹만 아래 목록에 표시": "* แสดงเฉพาะกลุ่มที่ใช้งานได้ในเวลานี้ (display_sets.time) ในรายการด้านล่าง",
    "* 저장은 UTC로 들어가고, 화면은 로컬 시간으로 입력/표시됨": "* บันทึกเป็น UTC แต่กรอกและแสดงบนหน้าจอตามเวลาท้องถิ่น",
    "* 필요할 때만 추가하면 됨": "* เพิ่มเมื่อจำเป็นเท่านั้น",
    "* 현재 기준시간 주변(±15~45일)에 기간(range) 설정된 DisplaySet이 없습니다.": "* ไม่มี DisplaySet ที่กำหนดช่วงเวลา (range) ใกล้เวลาปัจจุบัน (±15–45 วัน)",
    "+ 타이머(표시여부)": "+ ตัวจับเวลา (แสดงหรือไม่)",
    "- PENDING 는 저장만 되고 노출되지 않음": "- PENDING จะบันทึกเท่านั้นและไม่แสดง",
    "- SCHEDULED 는 startAt 이후 자동 노출": "- SCHEDULED จะแสดงอัตโนมัติหลัง startAt",
    "- endAt 이 지나면 자동 만료": "- หมดอายุอัตโนมัติหลัง endAt",
    "/community/notice/1 또는 https://...": "/community/notice/1 หรือ https://...",
    "Due Date 지정": "กำหนดวันครบกำหนด",
    "Due Date(관리자 로컬 시간)": "วันครบกำหนด (เวลาท้องถิ่นของผู้ดูแล)",
    "RUN 생성: 미션 총 베팅금(target_total_bet) 입력": "สร้าง RUN: กรอกยอดเดิมพันรวมของภารกิจ (target_total_bet)",
    "RUN 생성: 테이블 미션 총 베팅금(target_total_bet) 입력": "สร้าง RUN: กรอกยอดเดิมพันรวมของภารกิจโต๊ะ (target_total_bet)",
    "USDT TRC20 테스트넷": "เครือข่ายทดสอบ USDT TRC20",
    "endAt (종료, 선택)": "endAt (สิ้นสุด, ไม่บังคับ)",
    "index(선택)": "index (ไม่บังคับ)",
    "reserve_time_utc(표시:로컬)": "reserve_time_utc (แสดง: เวลาท้องถิ่น)",
    "reserve_time_utc가 지난 waiting들을 running으로 전환": "เปลี่ยนรายการ waiting ที่ผ่าน reserve_time_utc เป็น running",
    "startAt (시작)": "startAt (เริ่ม)",
    "status(선택)": "status (ไม่บังคับ)",
    "superadmin 전용 UI (admin-server / DB 저장)": "UI เฉพาะ superadmin (admin-server / บันทึก DB)",
    "tick 실패": "tick ล้มเหลว",
    "{targetId} 삭제하시겠습니까?": "ลบ {targetId} หรือไม่?",
    "※ 이미지는 admin server 의": "※ รูปภาพอยู่ใน admin server ที่",
    "※ 입력이 없으면 0%로 처리됩니다.": "※ หากไม่กรอกจะถือเป็น 0%",
    "※ 입력이 없으면 0.00%로 처리됩니다.": "※ หากไม่กรอกจะถือเป็น 0.00%",
    "※ 현재 저장은 admin-server API를 통해 DB에 반영됨.": "※ การบันทึกปัจจุบันจะเขียนลง DB ผ่าน API admin-server",
    "→ 하위는": "→ ระดับล่างได้รับ",
    "같은 area라도 device/country가 다르면 각각 별도 row로 저장돼.": "แม้ area เดียวกัน หาก device/country ต่างกันจะบันทึกเป็น row แยกกัน",
    "갱신 중": "กำลังอัปเดต",
    "공지 목록 불러오는 중...": "กำลังโหลดรายการประกาศ...",
    "공지 목록을 불러오지 못했어.\n{message}": "โหลดรายการประกาศไม่สำเร็จ\n{message}",
    "공지 삭제에 실패했어.\n{message}": "ลบประกาศไม่สำเร็จ\n{message}",
    "공지 삭제할까?\n\n- {title}": "ลบประกาศหรือไม่?\n\n- {title}",
    "공지 저장에 실패했어.\n{message}": "บันทึกประกาศไม่สำเร็จ\n{message}",
    "광고 목록 불러오는 중...": "กำลังโหลดรายการโฆษณา...",
    "광고를 삭제할까?\n\n- {label}": "ลบโฆษณาหรือไม่?\n\n- {label}",
    "그룹 미션 RUN 중지?\nrun_id={runId}": "หยุด RUN ภารกิจกลุ่มหรือไม่?\nrun_id={runId}",
    "그룹 미션 중지 실패 (백엔드에 DELETE /admin/mission/run/:run_id 필요)": "หยุดภารกิจกลุ่มไม่สำเร็จ (backend ต้องมี DELETE /admin/mission/run/:run_id)",
    "그룹은 삭제됐지만 Redis 정리가 실패했습니다. (code={code})": "ลบกลุ่มแล้วแต่ล้าง Redis ไม่สำเร็จ (code={code})",
    "링크는 http:// 또는 https:// 로 시작해야 해.": "ลิงก์ต้องขึ้นต้นด้วย http:// หรือ https://",
    "미션 총 베팅금(target_total_bet)을 입력": "กรอกยอดเดิมพันรวมของภารกิจ (target_total_bet)",
    "미입력시 자동": "อัตโนมัติหากไม่กรอก",
    "백엔드에 종료 API가 있어야 실제 중지됨": "backend ต้องมี API สิ้นสุดจึงจะหยุดจริง",
    "비워두면 클릭 이동 없음": "เว้นว่างเพื่อไม่ให้คลิกแล้วไปหน้าอื่น",
    "상단 고정(📌)": "ปักหมุดด้านบน (📌)",
    "상위 에이전트의 수수료(": "ค่าธรรมเนียมของเอเจนต์ระดับบน (",
    "상태 보기 (테이블 미션 raw)": "ดูสถานะ (raw ภารกิจโต๊ะ)",
    "생성 에러:": "ข้อผิดพลาดในการสร้าง:",
    "수정(설정)": "แก้ไข (การตั้งค่า)",
    "시작(생성)": "เริ่ม (สร้าง)",
    "아이디": "ID",
    "아이콘 업로드 실패 (서버 업로드 API 확인 필요)": "อัปโหลดไอคอนไม่สำเร็จ (ตรวจสอบ API อัปโหลดของเซิร์ฟเวอร์)",
    "아이콘(로컬 업로드/URL)": "ไอคอน (อัปโหลดในเครื่อง/URL)",
    "업로드하면 /uploads/... 로 자동 입력됨 (또는 URL 직접 입력)": "เมื่ออัปโหลดจะกรอก /uploads/... อัตโนมัติ (หรือกรอก URL โดยตรง)",
    "에이전트 분배 비율(agent_share) 입력 (예: 0.2 = 20%)": "กรอกสัดส่วนแบ่งของเอเจนต์ (agent_share) เช่น 0.2 = 20%",
    "예: HOT": "ตัวอย่าง: HOT",
    "예: KR / US / JP / ALL": "ตัวอย่าง: KR / US / JP / ALL",
    "예: NEW YEAR EVENT START!": "ตัวอย่าง: NEW YEAR EVENT START!",
    "예: VIP NLH 1/2": "ตัวอย่าง: VIP NLH 1/2",
    "예: 메인 KR 모바일 상단 배너": "ตัวอย่าง: แบนเนอร์บนสุดมือถือ KR หลัก",
    "예: 오늘만 레이크 0%": "ตัวอย่าง: วันนี้เท่านั้น rake 0%",
    "예: 🔥 12/31 이벤트 진행중": "ตัวอย่าง: 🔥 กิจกรรม 12/31 กำลังดำเนินอยู่",
    "예: 🔧HOT": "ตัวอย่าง: 🔧HOT",
    "예약 tick": "tick ตามกำหนด",
    "예약 보류": "พักกำหนดการ",
    "예약 사용": "ใช้กำหนดการ",
    "예약 상태면 startAt(시작일시)를 넣어줘.": "หากเป็นสถานะตามกำหนด ให้กรอก startAt (เวลาเริ่ม)",
    "예약 없음 → 즉시 진행(running)으로 자동 설정됨": "ไม่มีกำหนดการ → ตั้งเป็น running ทันทีโดยอัตโนมัติ",
    "예약(reserve_time_utc)": "กำหนดการ (reserve_time_utc)",
    "예약보류": "พักกำหนดการ",
    "왼쪽에서 공지를 선택해줘.": "เลือกประกาศทางซ้าย",
    "왼쪽에서 광고를 선택해줘.": "เลือกโฆษณาทางซ้าย",
    "을 눌러야 서버에 반영됨": "ต้องกดจึงจะนำไปใช้บนเซิร์ฟเวอร์",
    "이미 테이블 미션 RUN이 실행 중입니다.\n(run_id={runId})\n재시작(기존 RUN 삭제 후 새로 생성)할까요?": "RUN ภารกิจโต๊ะกำลังทำงานอยู่แล้ว\n(run_id={runId})\nเริ่มใหม่โดยลบ RUN เดิมและสร้างใหม่หรือไม่?",
    "이미지 넣기": "เพิ่มรูปภาพ",
    "이미지는 본문 안에 [image-번호] 형태로 표시됨.": "รูปภาพจะแสดงในเนื้อหาเป็น [image-หมายเลข]",
    "인포 버튼 프리셋 수정 실패": "แก้ไข preset ปุ่มข้อมูลไม่สำเร็จ",
    "인포버튼 프리셋 수정 실패": "แก้ไข preset ปุ่ม info ไม่สำเร็จ",
    "인포카드 추가 실패": "เพิ่มการ์ดข้อมูลไม่สำเร็จ",
    "잠금 비밀번호": "รหัสผ่านล็อก",
    "저장 시 실제 이미지 URL 토큰으로 자동 변환됨.": "เมื่อบันทึกจะถูกแปลงเป็นโทเคน URL รูปภาพจริงโดยอัตโนมัติ",
    "저장됩니다. 기준 시간은 위 인포카드 타이머 설정(timerMode/timerEndUtc)을 사용합니다.": "จะถูกบันทึก โดยใช้เวลามาตรฐานจากการตั้งค่าตัวจับเวลาของการ์ดข้อมูลด้านบน (timerMode/timerEndUtc)",
    "전광판": "ป้ายไฟ",
    "전광판 삭제?\n(id={id})": "ลบป้ายไฟหรือไม่?\n(id={id})",
    "정렬 화살표는 같은 area/device/country 묶음 안에서만 동작해.": "ลูกศรเรียงลำดับทำงานเฉพาะภายในกลุ่ม area/device/country เดียวกัน",
    "줄바꿈 그대로 표시됨.": "แสดงการขึ้นบรรทัดใหม่ตามเดิม",
    "중지(삭제)": "หยุด (ลบ)",
    "체크하지 않으면 앞으로 새로 생성되는 테이블에만 적용됩니다.": "หากไม่เลือก จะใช้กับโต๊ะที่สร้างใหม่หลังจากนี้เท่านั้น",
    "추가": "เพิ่ม",
    "테이블 그룹 삭제?\n({displayCode})": "ลบกลุ่มโต๊ะหรือไม่?\n({displayCode})",
    "테이블 미션 RUN 중지(그룹 전체 적용)?\n(display_code={displayCode})": "หยุด RUN ภารกิจโต๊ะสำหรับทั้งกลุ่มหรือไม่?\n(display_code={displayCode})",
    "테이블 미션 에이전트 분배 비율(agent_share) 입력 (예: 0.2 = 20%)": "กรอกสัดส่วนแบ่งเอเจนต์ของภารกิจโต๊ะ (agent_share) เช่น 0.2 = 20%",
    "테이블 미션 총 베팅금(target_total_bet)을 입력": "กรอกยอดเดิมพันรวมของภารกิจโต๊ะ (target_total_bet)",
    "폴더에 저장되고, DB에는 메타/경로만 저장돼.": "บันทึกในโฟลเดอร์ โดย DB เก็บเฉพาะเมทาดาทาและพาธ",
    "현재 index 값들을 서버에 저장": "บันทึกค่า index ปัจจุบันไปยังเซิร์ฟเวอร์",
    "현재 활성 테이블에도 즉시 적용": "นำไปใช้กับโต๊ะที่กำลังใช้งานทันที"
  },
  "ja": {
    "%) 중 몇 %를 하위에게 분배하시겠습니까?": "%)のうち何%を下位に分配しますか？",
    "(password 있음)": "（パスワードあり）",
    "(링크 없음)": "（リンクなし）",
    "(본문 없음)": "（本文なし）",
    "(없음)": "（なし）",
    "(여기 클릭하면 새 공지 모달 오픈)": "（ここをクリックすると新規お知らせモーダルを開きます）",
    "(이름없음)": "（名前なし）",
    "(자동)": "（自動）",
    "* index를 바꾼 뒤": "* indexを変更した後",
    "* 무한 모드일 때 UI상 “30일마다 갱신”로 표시용": "* 無限モード時にUI上で「30日ごとに更新」と表示するため",
    "* 예: 상위 50% 중": "* 例：上位50%のうち",
    "* 이 설정은 인포카드 내부 카운트다운 기준입니다. 위 시간 설정은 로비 노출 기간만 제어합니다.": "* この設定は情報カード内部のカウントダウン基準です。上の時間設定はロビーの表示期間のみを制御します。",
    "* 이 스타일은 인포카드의 text 요소에만 적용됩니다. 타이머/아이콘은 기존 스타일을 유지합니다.": "* このスタイルは情報カードのtext要素にのみ適用されます。タイマー／アイコンは既存スタイルを維持します。",
    "* 이 시간에 “유효한(display_sets.time)” 그룹만 아래 목록에 표시": "* この時刻に有効な（display_sets.time）グループのみ下の一覧に表示",
    "* 저장은 UTC로 들어가고, 화면은 로컬 시간으로 입력/표시됨": "* UTCで保存され、画面ではローカル時刻で入力・表示されます",
    "* 필요할 때만 추가하면 됨": "* 必要な場合のみ追加してください",
    "* 현재 기준시간 주변(±15~45일)에 기간(range) 설정된 DisplaySet이 없습니다.": "* 現在の基準時刻付近（±15～45日）に期間（range）が設定されたDisplaySetはありません。",
    "+ 공지 작성": "+ お知らせ作成",
    "+ 광고 등록": "+ 広告登録",
    "+ 새 공지 작성": "+ 新しいお知らせを作成",
    "+ 새 광고 등록": "+ 新しい広告を登録",
    "+ 아이콘(업로드)": "+ アイコン（アップロード）",
    "+ 이미지": "+ 画像",
    "+ 인포 버튼 추가": "+ 情報ボタン追加",
    "+ 인포카드 추가": "+ 情報カード追加",
    "+ 타이머(표시여부)": "+ タイマー（表示有無）",
    "- PENDING 는 저장만 되고 노출되지 않음": "- PENDINGは保存のみで表示されません",
    "- SCHEDULED 는 startAt 이후 자동 노출": "- SCHEDULEDはstartAt以降に自動表示されます",
    "- endAt 이 지나면 자동 만료": "- endAtを過ぎると自動的に期限切れになります",
    "/community/notice/1 또는 https://...": "/community/notice/1 または https://...",
    "0보다 큰 숫자만 가능": "0より大きい数値のみ使用可能",
    "DisplaySet 날짜 필터(1일 단위)": "DisplaySet日付フィルター（1日単位）",
    "Due Date 지정": "期限を指定",
    "Due Date(관리자 로컬 시간)": "期限（管理者のローカル時刻）",
    "Due Date를 올바른 날짜/시간으로 입력해야 합니다.": "正しい期限日時を入力してください。",
    "Due Date를 입력해야 합니다.": "期限を入力してください。",
    "RUN 생성: 미션 총 베팅금(target_total_bet) 입력": "RUN作成：ミッション総ベット額（target_total_bet）を入力",
    "RUN 생성: 테이블 미션 총 베팅금(target_total_bet) 입력": "RUN作成：テーブルミッション総ベット額（target_total_bet）を入力",
    "SB/BB는 0보다 큰 숫자이며 소수점은 최대 2자리까지 입력할 수 있습니다. 예: 0.25 / 0.50": "SB/BBは0より大きい数値で、小数点以下2桁まで入力できます。例：0.25 / 0.50",
    "USDT TRC20 테스트넷": "USDT TRC20テストネット",
    "agent_share는 0~1 사이 숫자만 가능 (예: 0.2)": "agent_shareは0～1の数値のみ使用できます（例：0.2）",
    "all / 데스크톱+모바일": "all / デスクトップ＋モバイル",
    "desktop / 데스크톱": "desktop / デスクトップ",
    "endAt (종료, 선택)": "endAt（終了、任意）",
    "endAt은 startAt보다 늦어야 해.": "endAtはstartAtより後である必要があります。",
    "index(선택)": "index（任意）",
    "message는 빈값이 될 수 없습니다.": "messageを空にすることはできません。",
    "message는 필수입니다.": "messageは必須です。",
    "mobile / 모바일": "mobile / モバイル",
    "reserve_time_utc(표시:로컬)": "reserve_time_utc（表示：ローカル）",
    "reserve_time_utc가 지난 waiting들을 running으로 전환": "reserve_time_utcを過ぎたwaitingをrunningに変更",
    "startAt (시작)": "startAt（開始）",
    "status(선택)": "status（任意）",
    "superadmin 전용 UI (admin-server / DB 저장)": "スーパー管理者専用UI（admin-server / DB保存）",
    "tick 실패": "tick失敗",
    "{targetId} 삭제하시겠습니까?": "{targetId}を削除しますか？",
    "※ 이미지는 admin server 의": "※ 画像はadmin serverの",
    "※ 입력이 없으면 0%로 처리됩니다.": "※ 未入力の場合は0%として処理されます。",
    "※ 입력이 없으면 0.00%로 처리됩니다.": "※ 未入力の場合は0.00%として処理されます。",
    "※ 현재 저장은 admin-server API를 통해 DB에 반영됨.": "※ 現在の保存内容はadmin-server APIを通じてDBに反映されます。",
    "→ 하위는": "→ 下位は",
    "같은 area라도 device/country가 다르면 각각 별도 row로 저장돼.": "同じareaでもdevice/countryが異なる場合は別々のrowとして保存されます。",
    "갱신 주기(일)": "更新周期（日）",
    "갱신 중": "更新中",
    "검색: 이름/링크/국가": "検索：名前／リンク／国",
    "검색: 제목/본문/작성자": "検索：タイトル／本文／作成者",
    "공지 목록 불러오는 중...": "お知らせ一覧を読み込み中...",
    "공지 목록을 불러오지 못했어.\n{message}": "お知らせ一覧を読み込めませんでした。\n{message}",
    "공지 삭제에 실패했어.\n{message}": "お知らせの削除に失敗しました。\n{message}",
    "공지 삭제할까?\n\n- {title}": "お知らせを削除しますか？\n\n- {title}",
    "공지 저장에 실패했어.\n{message}": "お知らせの保存に失敗しました。\n{message}",
    "공지가 없어. 위에서 새로 작성해줘.": "お知らせがありません。上で新規作成してください。",
    "광고 목록 불러오는 중...": "広告一覧を読み込み中...",
    "광고 목록을 불러오지 못했어.": "広告一覧を読み込めませんでした。",
    "광고 삭제에 실패했어.": "広告の削除に失敗しました。",
    "광고 이미지를 업로드해줘.": "広告画像をアップロードしてください。",
    "광고 저장에 실패했어.": "広告の保存に失敗しました。",
    "광고를 삭제할까?\n\n- {label}": "広告を削除しますか？\n\n- {label}",
    "구분": "区分",
    "국가(country)를 입력해줘. 예: KR / US / JP / ALL": "国（country）を入力してください。例：KR / US / JP / ALL",
    "그룹 미션": "グループミッション",
    "그룹 미션 RUN 중지?\nrun_id={runId}": "グループミッションRUNを停止しますか？\nrun_id={runId}",
    "그룹 미션 설정": "グループミッション設定",
    "그룹 미션 시작": "グループミッション開始",
    "그룹 미션 중지 실패 (백엔드에 DELETE /admin/mission/run/:run_id 필요)": "グループミッションの停止に失敗しました（バックエンドにDELETE /admin/mission/run/:run_idが必要）",
    "그룹 시간 설정이 올바르지 않습니다.": "グループの時間設定が正しくありません。",
    "그룹 이름, Small Blind, Big Blind는 필수 입력입니다. SB/BB는 예: 0.25, 0.50처럼 입력할 수 있습니다.": "グループ名、Small Blind、Big Blindは必須です。SB/BBは0.25、0.50のように入力できます。",
    "그룹은 삭제됐지만 Redis 정리가 실패했습니다. (code={code})": "グループは削除されましたがRedisのクリーンアップに失敗しました。（code={code}）",
    "글로벌": "グローバル",
    "내부용 이름(label)": "内部名（label）",
    "내부용 이름(label)을 입력해줘.": "内部名（label）を入力してください。",
    "노출": "表示",
    "노출(즉시/기간무관)": "表示（即時／期間無関係）",
    "노출중": "表示中",
    "닉네임": "ニックネーム",
    "대상": "対象",
    "데스크톱": "デスクトップ",
    "등록": "登録",
    "등록된 광고가 없어.": "登録された広告はありません。",
    "등록된 이미지 없음": "登録画像なし",
    "라운지 포인트 %": "ラウンジポイント%",
    "라운지 포인트 % (0~100)": "ラウンジポイント%（0～100）",
    "라운지 포인트 %는 0~100 사이 숫자이며 소수점은 최대 2자리까지 가능합니다.": "ラウンジポイント%は0～100の数値で、小数点以下2桁まで入力できます。",
    "레이크백": "レークバック",
    "링크:": "リンク：",
    "링크는 http:// 또는 https:// 로 시작해야 해.": "リンクはhttp://またはhttps://で始める必要があります。",
    "메모": "メモ",
    "메인 영역": "メイン領域",
    "모바일": "モバイル",
    "무한(infinite) 항목(상시 노출)": "無限（infinite）項目（常時表示）",
    "무한(약 {days}일 단위 갱신)": "無限（約{days}日ごとに更新）",
    "미션 RUN 생성 실패": "ミッションRUNの作成に失敗しました",
    "미션 cfg 저장 실패": "ミッションcfgの保存に失敗しました",
    "미션 상금 분배(프론트 계산)": "ミッション賞金配分（フロント計算）",
    "미션 상태 조회 실패": "ミッション状態の取得に失敗しました",
    "미션 총 베팅금(target_total_bet)을 입력": "ミッション総ベット額（target_total_bet）を入力",
    "미입력시 자동": "未入力時は自動",
    "배치": "バッチ",
    "백엔드에 종료 API가 있어야 실제 중지됨": "実際に停止するにはバックエンドに終了APIが必要です",
    "본문을 입력해줘.": "本文を入力してください。",
    "비밀번호": "パスワード",
    "비워두면 클릭 이동 없음": "空欄の場合はクリック移動なし",
    "상단 고정(📌)": "上部固定（📌）",
    "상위 에이전트의 수수료(": "上位エージェントの手数料（",
    "상태 보기 (테이블 미션 raw)": "状態を表示（テーブルミッションraw）",
    "새 전광판 등록": "新しい電光掲示板を登録",
    "생성 에러:": "作成エラー：",
    "서버로 전송될 preset 문자열(콤마 구분)": "サーバーに送信するpreset文字列（カンマ区切り）",
    "수정(설정)": "編集（設定）",
    "시간 설정": "時間設定",
    "시간 설정이 올바르지 않습니다.": "時間設定が正しくありません。",
    "시작(생성)": "開始（作成）",
    "아이디": "ID",
    "아이콘 업로드 실패 (서버 업로드 API 확인 필요)": "アイコンのアップロードに失敗しました（サーバーのアップロードAPIを確認してください）",
    "아이콘 파일은 1MB 이하로 올려주세요.": "アイコンファイルは1MB以下でアップロードしてください。",
    "아이콘(로컬 업로드/URL)": "アイコン（ローカルアップロード／URL）",
    "아프리카": "アフリカ",
    "업로드 URL을 받지 못했어.": "アップロードURLを取得できませんでした。",
    "업로드하면 /uploads/... 로 자동 입력됨 (또는 URL 직접 입력)": "アップロードすると/uploads/...が自動入力されます（またはURLを直接入力）",
    "에이전트": "エージェント",
    "에이전트 분배 비율(agent_share) 입력 (예: 0.2 = 20%)": "エージェント配分率（agent_share）を入力（例：0.2 = 20%）",
    "에이전트 상금풀(": "エージェント賞金プール（",
    "예: HOT": "例：HOT",
    "예: KR / US / JP / ALL": "例：KR / US / JP / ALL",
    "예: NEW YEAR EVENT START!": "例：NEW YEAR EVENT START!",
    "예: VIP NLH 1/2": "例：VIP NLH 1/2",
    "예: 메인 KR 모바일 상단 배너": "例：メインKRモバイル上部バナー",
    "예: 오늘만 레이크 0%": "例：本日だけレーク0%",
    "예: 🔥 12/31 이벤트 진행중": "例：🔥 12/31イベント開催中",
    "예: 🔧HOT": "例：🔧HOT",
    "예약 tick": "予約tick",
    "예약 보류": "予約保留",
    "예약 사용": "予約を使用",
    "예약 상태면 startAt(시작일시)를 넣어줘.": "予約状態の場合はstartAt（開始日時）を入力してください。",
    "예약 시간이 올바르지 않습니다.": "予約時間が正しくありません。",
    "예약 없음 → 즉시 진행(running)으로 자동 설정됨": "予約なし → 即時進行（running）に自動設定",
    "예약(reserve_time_utc)": "予約（reserve_time_utc）",
    "예약/상태": "予約／状態",
    "예약보류": "予約保留",
    "왼쪽에서 공지를 선택해줘.": "左側からお知らせを選択してください。",
    "왼쪽에서 광고를 선택해줘.": "左側から広告を選択してください。",
    "요소(최대 4개)": "要素（最大4個）",
    "요청 실패 ({status})": "リクエスト失敗（{status}）",
    "용량": "容量",
    "유럽": "ヨーロッパ",
    "유효 인포메이션 버튼:": "有効な情報ボタン：",
    "을 눌러야 서버에 반영됨": "を押すとサーバーに反映されます",
    "이동 URL": "移動先URL",
    "이메일": "メール",
    "이미 테이블 미션 RUN이 실행 중입니다.\n(run_id={runId})\n재시작(기존 RUN 삭제 후 새로 생성)할까요?": "テーブルミッションRUNはすでに実行中です。\n（run_id={runId}）\n再起動（既存RUNを削除して新規作成）しますか？",
    "이미지": "画像",
    "이미지 넣기": "画像を追加",
    "이미지 업로드 실패: {message}": "画像のアップロードに失敗しました：{message}",
    "이미지 업로드중...": "画像をアップロード中...",
    "이미지 없음": "画像なし",
    "이미지 열기": "画像を開く",
    "이미지 파일만 등록할 수 있어.": "画像ファイルのみ登録できます。",
    "이미지 파일만 업로드할 수 있어.": "画像ファイルのみアップロードできます。",
    "이미지(URL)": "画像（URL）",
    "이미지는 5MB 이하만 업로드할 수 있어.": "画像は5MB以下のみアップロードできます。",
    "이미지는 본문 안에 [image-번호] 형태로 표시됨.": "画像は本文内に[image-番号]形式で表示されます。",
    "인포 버튼 시간 설정이 올바르지 않습니다.": "情報ボタンの時間設定が正しくありません。",
    "인포 버튼 프리셋 수정": "情報ボタンプリセットを編集",
    "인포 버튼 프리셋 수정 실패": "情報ボタンプリセットの編集に失敗しました",
    "인포메이션 버튼(선택)": "情報ボタン（任意）",
    "인포버튼 없음": "情報ボタンなし",
    "인포버튼 프리셋 수정": "情報ボタンプリセットを編集",
    "인포버튼 프리셋 수정 실패": "情報ボタンプリセットの編集に失敗しました",
    "인포카드 추가": "情報カードを追加",
    "인포카드 추가 실패": "情報カードの追加に失敗しました",
    "인포카드 타이머": "情報カードタイマー",
    "임시": "一時",
    "임시저장": "下書き保存",
    "자산": "資産",
    "작성자": "作成者",
    "잠금 비밀번호": "ロックパスワード",
    "재시작": "再起動",
    "저장 시 실제 이미지 URL 토큰으로 자동 변환됨.": "保存時に実際の画像URLトークンへ自動変換されます。",
    "저장됩니다. 기준 시간은 위 인포카드 타이머 설정(timerMode/timerEndUtc)을 사용합니다.": "保存されます。基準時刻は上の情報カードタイマー設定（timerMode/timerEndUtc）を使用します。",
    "저장중...": "保存中...",
    "전광판": "電光掲示板",
    "전광판 관리": "電光掲示板管理",
    "전광판 등록 실패": "電光掲示板の登録に失敗しました",
    "전광판 목록 조회 실패": "電光掲示板一覧の取得に失敗しました",
    "전광판 삭제 실패": "電光掲示板の削除に失敗しました",
    "전광판 삭제?\n(id={id})": "電光掲示板を削除しますか？\n（id={id}）",
    "전광판 수정 실패": "電光掲示板の編集に失敗しました",
    "정렬 변경에 실패했어.": "並び順の変更に失敗しました。",
    "정렬 저장": "並び順を保存",
    "정렬 저장 실패": "並び順の保存に失敗しました",
    "정렬 화살표는 같은 area/device/country 묶음 안에서만 동작해.": "並び替え矢印は同じarea/device/countryグループ内でのみ動作します。",
    "정상": "正常",
    "제목을 입력해줘.": "タイトルを入力してください。",
    "조회": "照会",
    "줄바꿈 그대로 표시됨.": "改行をそのまま表示します。",
    "중동": "中東",
    "중앙아시아": "中央アジア",
    "중지(삭제)": "停止（削除）",
    "지금": "現在",
    "지급 실패": "支給失敗",
    "직속": "直属",
    "차감 실패": "差し引き失敗",
    "체크하지 않으면 앞으로 새로 생성되는 테이블에만 적용됩니다.": "チェックしない場合、今後新しく作成されるテーブルにのみ適用されます。",
    "총": "合計",
    "총 상금풀(1.5%):": "賞金プール合計（1.5%）：",
    "총베팅액:": "総ベット額：",
    "추가": "追加",
    "크기(px)": "サイズ（px）",
    "클릭 이동 URL(link_url)": "クリック移動URL（link_url）",
    "클릭 이동 링크(URL)": "クリック移動リンク（URL）",
    "클릭하면 등록 모달": "クリックすると登録モーダルを開きます",
    "클릭하면 표시 기준 시간이 해당 날짜로 설정됩니다": "クリックすると表示基準時刻がその日付に設定されます",
    "타이머 없음": "タイマーなし",
    "타이머 타입": "タイマータイプ",
    "타이머(존재유무만)": "タイマー（有無のみ）",
    "타이머는": "タイマーは",
    "타입": "タイプ",
    "테이블 그룹 목록 조회 실패": "テーブルグループ一覧の取得に失敗しました",
    "테이블 그룹 삭제?\n({displayCode})": "テーブルグループを削除しますか？\n（{displayCode}）",
    "테이블 그룹 생성 실패": "テーブルグループの作成に失敗しました",
    "테이블 그룹 생성 완료": "テーブルグループを作成しました",
    "테이블 그룹 코드 생성 실패": "テーブルグループコードの作成に失敗しました",
    "테이블 그룹이 없습니다.": "テーブルグループがありません。",
    "테이블 미션 RUN 생성 실패": "テーブルミッションRUNの作成に失敗しました",
    "테이블 미션 RUN 중지 실패": "テーブルミッションRUNの停止に失敗しました",
    "테이블 미션 RUN 중지(그룹 전체 적용)?\n(display_code={displayCode})": "テーブルミッションRUNを停止しますか（グループ全体に適用）？\n（display_code={displayCode}）",
    "테이블 미션 cfg 저장 실패": "テーブルミッションcfgの保存に失敗しました",
    "테이블 미션 상금 분배(프론트 계산)": "テーブルミッション賞金配分（フロント計算）",
    "테이블 미션 상태 조회 실패": "テーブルミッション状態の取得に失敗しました",
    "테이블 미션 에이전트 분배 비율(agent_share) 입력 (예: 0.2 = 20%)": "テーブルミッションのエージェント配分率（agent_share）を入力（例：0.2 = 20%）",
    "테이블 미션 총 베팅금(target_total_bet)을 입력": "テーブルミッション総ベット額（target_total_bet）を入力",
    "텍스트": "テキスト",
    "텍스트 스타일": "テキストスタイル",
    "파일명": "ファイル名",
    "페이지": "ページ",
    "폴더에 저장되고, DB에는 메타/경로만 저장돼.": "フォルダーに保存され、DBにはメタ情報／パスのみ保存されます。",
    "표시 기준 시간": "表示基準時刻",
    "표시 순서(order)": "表示順（order）",
    "표시 여부만": "表示有無のみ",
    "프리셋(배경/요소/URL)": "プリセット（背景／要素／URL）",
    "플레이어 상금풀(": "プレイヤー賞金プール（",
    "현재 index 값들을 서버에 저장": "現在のindex値をサーバーに保存",
    "현재 활성 테이블에도 즉시 적용": "現在アクティブなテーブルにもすぐ適用",
    "활성 RUN이 없습니다.": "アクティブなRUNはありません。"
  },
  "it": {
    "%) 중 몇 %를 하위에게 분배하시겠습니까?": "%) quale percentuale vuoi distribuire al livello inferiore?",
    "(password 있음)": "(password impostata)",
    "(링크 없음)": "(nessun link)",
    "(본문 없음)": "(nessun contenuto)",
    "(없음)": "(nessuno)",
    "(여기 클릭하면 새 공지 모달 오픈)": "(fai clic qui per aprire la finestra del nuovo avviso)",
    "(이름없음)": "(senza nome)",
    "(자동)": "(automatico)",
    "* index를 바꾼 뒤": "* Dopo aver modificato index",
    "* 무한 모드일 때 UI상 “30일마다 갱신”로 표시용": "* In modalità infinita, visualizzato nell’interfaccia come ‘si rinnova ogni 30 giorni’",
    "* 예: 상위 50% 중": "* Esempio: del 50% superiore",
    "* 이 설정은 인포카드 내부 카운트다운 기준입니다. 위 시간 설정은 로비 노출 기간만 제어합니다.": "* Questa impostazione controlla il conto alla rovescia interno della scheda informativa. Le impostazioni temporali sopra controllano solo il periodo di esposizione nella lobby.",
    "* 이 스타일은 인포카드의 text 요소에만 적용됩니다. 타이머/아이콘은 기존 스타일을 유지합니다.": "* Questo stile si applica solo agli elementi text della scheda informativa. Timer e icone mantengono lo stile esistente.",
    "* 이 시간에 “유효한(display_sets.time)” 그룹만 아래 목록에 표시": "* Nell’elenco sotto vengono mostrati solo i gruppi validi in questo momento (display_sets.time)",
    "* 저장은 UTC로 들어가고, 화면은 로컬 시간으로 입력/표시됨": "* Salvato in UTC; inserito e visualizzato sullo schermo in ora locale",
    "* 필요할 때만 추가하면 됨": "* Aggiungi solo quando necessario",
    "* 현재 기준시간 주변(±15~45일)에 기간(range) 설정된 DisplaySet이 없습니다.": "* Non esiste alcun DisplaySet con un periodo (range) vicino all’ora di riferimento corrente (±15–45 giorni).",
    "+ 공지 작성": "+ Crea avviso",
    "+ 광고 등록": "+ Registra annuncio",
    "+ 새 공지 작성": "+ Crea nuovo avviso",
    "+ 새 광고 등록": "+ Registra nuovo annuncio",
    "+ 아이콘(업로드)": "+ Icona (caricamento)",
    "+ 이미지": "+ Immagine",
    "+ 인포 버튼 추가": "+ Aggiungi pulsante informativo",
    "+ 인포카드 추가": "+ Aggiungi scheda informativa",
    "+ 타이머(표시여부)": "+ Timer (visibilità)",
    "- PENDING 는 저장만 되고 노출되지 않음": "- PENDING viene solo salvato e non mostrato",
    "- SCHEDULED 는 startAt 이후 자동 노출": "- SCHEDULED viene mostrato automaticamente dopo startAt",
    "- endAt 이 지나면 자동 만료": "- Scade automaticamente dopo endAt",
    "/community/notice/1 또는 https://...": "/community/notice/1 oppure https://...",
    "0보다 큰 숫자만 가능": "Sono consentiti solo numeri maggiori di 0",
    "DisplaySet 날짜 필터(1일 단위)": "Filtro data DisplaySet (unità di 1 giorno)",
    "Due Date 지정": "Imposta data di scadenza",
    "Due Date(관리자 로컬 시간)": "Data di scadenza (ora locale amministratore)",
    "Due Date를 올바른 날짜/시간으로 입력해야 합니다.": "Inserisci una data e ora di scadenza valida.",
    "Due Date를 입력해야 합니다.": "La data di scadenza è obbligatoria.",
    "RUN 생성: 미션 총 베팅금(target_total_bet) 입력": "Crea RUN: inserisci la puntata totale della missione (target_total_bet)",
    "RUN 생성: 테이블 미션 총 베팅금(target_total_bet) 입력": "Crea RUN: inserisci la puntata totale della missione tavolo (target_total_bet)",
    "SB/BB는 0보다 큰 숫자이며 소수점은 최대 2자리까지 입력할 수 있습니다. 예: 0.25 / 0.50": "SB/BB devono essere numeri maggiori di 0 con massimo 2 decimali. Esempio: 0.25 / 0.50",
    "USDT TRC20 테스트넷": "Testnet USDT TRC20",
    "agent_share는 0~1 사이 숫자만 가능 (예: 0.2)": "agent_share deve essere un numero tra 0 e 1 (esempio: 0.2)",
    "all / 데스크톱+모바일": "all / Desktop + Mobile",
    "desktop / 데스크톱": "desktop / Desktop",
    "endAt (종료, 선택)": "endAt (fine, facoltativo)",
    "endAt은 startAt보다 늦어야 해.": "endAt deve essere successivo a startAt.",
    "index(선택)": "index (facoltativo)",
    "message는 빈값이 될 수 없습니다.": "message non può essere vuoto.",
    "message는 필수입니다.": "message è obbligatorio.",
    "mobile / 모바일": "mobile / Mobile",
    "reserve_time_utc(표시:로컬)": "reserve_time_utc (visualizzazione: locale)",
    "reserve_time_utc가 지난 waiting들을 running으로 전환": "Sposta in running gli elementi waiting oltre reserve_time_utc",
    "startAt (시작)": "startAt (inizio)",
    "status(선택)": "status (facoltativo)",
    "superadmin 전용 UI (admin-server / DB 저장)": "UI riservata al superadmin (admin-server / salvataggio DB)",
    "tick 실패": "tick non riuscito",
    "{targetId} 삭제하시겠습니까?": "Eliminare {targetId}?",
    "※ 이미지는 admin server 의": "※ Le immagini sono archiviate su admin server in",
    "※ 입력이 없으면 0%로 처리됩니다.": "※ Se vuoto, viene trattato come 0%.",
    "※ 입력이 없으면 0.00%로 처리됩니다.": "※ Se vuoto, viene trattato come 0,00%.",
    "※ 현재 저장은 admin-server API를 통해 DB에 반영됨.": "※ Il salvataggio attuale viene scritto nel DB tramite l’API admin-server.",
    "→ 하위는": "→ Il livello inferiore riceve",
    "같은 area라도 device/country가 다르면 각각 별도 row로 저장돼.": "Anche con lo stesso area, device/country diversi vengono salvati come row separati.",
    "갱신 주기(일)": "Ciclo di rinnovo (giorni)",
    "갱신 중": "Aggiornamento in corso",
    "검색: 이름/링크/국가": "Cerca: nome/link/paese",
    "검색: 제목/본문/작성자": "Cerca: titolo/contenuto/autore",
    "공지 목록 불러오는 중...": "Caricamento elenco avvisi...",
    "공지 목록을 불러오지 못했어.\n{message}": "Impossibile caricare l’elenco avvisi.\n{message}",
    "공지 삭제에 실패했어.\n{message}": "Eliminazione avviso non riuscita.\n{message}",
    "공지 삭제할까?\n\n- {title}": "Eliminare l’avviso?\n\n- {title}",
    "공지 저장에 실패했어.\n{message}": "Salvataggio avviso non riuscito.\n{message}",
    "공지가 없어. 위에서 새로 작성해줘.": "Non ci sono avvisi. Creane uno nuovo sopra.",
    "광고 목록 불러오는 중...": "Caricamento elenco annunci...",
    "광고 목록을 불러오지 못했어.": "Impossibile caricare l’elenco annunci.",
    "광고 삭제에 실패했어.": "Eliminazione annuncio non riuscita.",
    "광고 이미지를 업로드해줘.": "Carica un’immagine per l’annuncio.",
    "광고 저장에 실패했어.": "Salvataggio annuncio non riuscito.",
    "광고를 삭제할까?\n\n- {label}": "Eliminare l’annuncio?\n\n- {label}",
    "구분": "Categoria",
    "국가(country)를 입력해줘. 예: KR / US / JP / ALL": "Inserisci il paese (country). Esempio: KR / US / JP / ALL",
    "그룹 미션": "Missione di gruppo",
    "그룹 미션 RUN 중지?\nrun_id={runId}": "Interrompere il RUN della missione di gruppo?\nrun_id={runId}",
    "그룹 미션 설정": "Impostazioni missione di gruppo",
    "그룹 미션 시작": "Avvia missione di gruppo",
    "그룹 미션 중지 실패 (백엔드에 DELETE /admin/mission/run/:run_id 필요)": "Interruzione missione di gruppo non riuscita (il backend richiede DELETE /admin/mission/run/:run_id)",
    "그룹 시간 설정이 올바르지 않습니다.": "Le impostazioni temporali del gruppo non sono valide.",
    "그룹 이름, Small Blind, Big Blind는 필수 입력입니다. SB/BB는 예: 0.25, 0.50처럼 입력할 수 있습니다.": "Nome gruppo, Small Blind e Big Blind sono obbligatori. SB/BB possono essere inseriti come 0.25, 0.50.",
    "그룹은 삭제됐지만 Redis 정리가 실패했습니다. (code={code})": "Il gruppo è stato eliminato, ma la pulizia Redis non è riuscita. (code={code})",
    "글로벌": "Globale",
    "내부용 이름(label)": "Nome interno (label)",
    "내부용 이름(label)을 입력해줘.": "Inserisci il nome interno (label).",
    "노출": "Visibile",
    "노출(즉시/기간무관)": "Visibile (immediato/indipendente dal periodo)",
    "노출중": "In esposizione",
    "닉네임": "Nickname",
    "대상": "Target",
    "데스크톱": "Desktop",
    "등록": "Registra",
    "등록된 광고가 없어.": "Nessun annuncio registrato.",
    "등록된 이미지 없음": "Nessuna immagine registrata",
    "라운지 포인트 %": "Punti lounge %",
    "라운지 포인트 % (0~100)": "Punti lounge % (0–100)",
    "라운지 포인트 %는 0~100 사이 숫자이며 소수점은 최대 2자리까지 가능합니다.": "Punti lounge % deve essere tra 0 e 100 con massimo 2 decimali.",
    "레이크백": "Rakeback",
    "링크:": "Link:",
    "링크는 http:// 또는 https:// 로 시작해야 해.": "Il link deve iniziare con http:// o https://.",
    "메모": "Nota",
    "메인 영역": "Area principale",
    "모바일": "Mobile",
    "무한(infinite) 항목(상시 노출)": "Elemento infinito (sempre visibile)",
    "무한(약 {days}일 단위 갱신)": "Infinito (rinnovo ogni circa {days} giorni)",
    "미션 RUN 생성 실패": "Creazione RUN missione non riuscita",
    "미션 cfg 저장 실패": "Salvataggio cfg missione non riuscito",
    "미션 상금 분배(프론트 계산)": "Distribuzione premio missione (calcolo frontend)",
    "미션 상태 조회 실패": "Lettura stato missione non riuscita",
    "미션 총 베팅금(target_total_bet)을 입력": "Inserisci la puntata totale della missione (target_total_bet)",
    "미입력시 자동": "Automatico se non inserito",
    "배치": "Batch",
    "백엔드에 종료 API가 있어야 실제 중지됨": "Per interrompere realmente serve un’API di chiusura nel backend",
    "본문을 입력해줘.": "Inserisci il contenuto.",
    "비밀번호": "Password",
    "비워두면 클릭 이동 없음": "Se vuoto, nessuna navigazione al clic",
    "상단 고정(📌)": "Fissa in alto (📌)",
    "상위 에이전트의 수수료(": "Commissione dell’agente superiore (",
    "상태 보기 (테이블 미션 raw)": "Visualizza stato (raw missione tavolo)",
    "새 전광판 등록": "Registra nuovo tabellone",
    "생성 에러:": "Errore di creazione:",
    "서버로 전송될 preset 문자열(콤마 구분)": "Stringa preset inviata al server (separata da virgole)",
    "수정(설정)": "Modifica (impostazioni)",
    "시간 설정": "Impostazioni orario",
    "시간 설정이 올바르지 않습니다.": "Le impostazioni orario non sono valide.",
    "시작(생성)": "Avvia (crea)",
    "아이디": "ID",
    "아이콘 업로드 실패 (서버 업로드 API 확인 필요)": "Caricamento icona non riuscito (controlla l’API di upload del server)",
    "아이콘 파일은 1MB 이하로 올려주세요.": "Carica un file icona di massimo 1 MB.",
    "아이콘(로컬 업로드/URL)": "Icona (caricamento locale/URL)",
    "아프리카": "Africa",
    "업로드 URL을 받지 못했어.": "URL di caricamento non ricevuto.",
    "업로드하면 /uploads/... 로 자동 입력됨 (또는 URL 직접 입력)": "Dopo il caricamento viene inserito automaticamente /uploads/... (oppure inserisci direttamente l’URL)",
    "에이전트": "Agente",
    "에이전트 분배 비율(agent_share) 입력 (예: 0.2 = 20%)": "Inserisci la quota di distribuzione dell’agente (agent_share), esempio: 0.2 = 20%",
    "에이전트 상금풀(": "Montepremi agente (",
    "예: HOT": "Esempio: HOT",
    "예: KR / US / JP / ALL": "Esempio: KR / US / JP / ALL",
    "예: NEW YEAR EVENT START!": "Esempio: NEW YEAR EVENT START!",
    "예: VIP NLH 1/2": "Esempio: VIP NLH 1/2",
    "예: 메인 KR 모바일 상단 배너": "Esempio: banner superiore mobile principale KR",
    "예: 오늘만 레이크 0%": "Esempio: rake 0% solo oggi",
    "예: 🔥 12/31 이벤트 진행중": "Esempio: 🔥 evento 12/31 in corso",
    "예: 🔧HOT": "Esempio: 🔧HOT",
    "예약 tick": "tick programmato",
    "예약 보류": "Programmazione sospesa",
    "예약 사용": "Usa programmazione",
    "예약 상태면 startAt(시작일시)를 넣어줘.": "Se programmato, inserisci startAt (data e ora di inizio).",
    "예약 시간이 올바르지 않습니다.": "L’orario programmato non è valido.",
    "예약 없음 → 즉시 진행(running)으로 자동 설정됨": "Nessuna programmazione → impostato automaticamente subito su running",
    "예약(reserve_time_utc)": "Programmazione (reserve_time_utc)",
    "예약/상태": "Programmazione/stato",
    "예약보류": "Programmazione sospesa",
    "왼쪽에서 공지를 선택해줘.": "Seleziona un avviso a sinistra.",
    "왼쪽에서 광고를 선택해줘.": "Seleziona un annuncio a sinistra.",
    "요소(최대 4개)": "Elementi (massimo 4)",
    "요청 실패 ({status})": "Richiesta non riuscita ({status})",
    "용량": "Capacità",
    "유럽": "Europa",
    "유효 인포메이션 버튼:": "Pulsanti informativi validi:",
    "을 눌러야 서버에 반영됨": "deve essere premuto per applicare al server",
    "이동 URL": "URL di destinazione",
    "이메일": "Email",
    "이미 테이블 미션 RUN이 실행 중입니다.\n(run_id={runId})\n재시작(기존 RUN 삭제 후 새로 생성)할까요?": "Un RUN della missione tavolo è già in esecuzione.\n(run_id={runId})\nRiavviare eliminando il RUN esistente e creandone uno nuovo?",
    "이미지": "Immagine",
    "이미지 넣기": "Aggiungi immagine",
    "이미지 업로드 실패: {message}": "Caricamento immagine non riuscito: {message}",
    "이미지 업로드중...": "Caricamento immagine...",
    "이미지 없음": "Nessuna immagine",
    "이미지 열기": "Apri immagine",
    "이미지 파일만 등록할 수 있어.": "È possibile registrare solo file immagine.",
    "이미지 파일만 업로드할 수 있어.": "È possibile caricare solo file immagine.",
    "이미지(URL)": "Immagine (URL)",
    "이미지는 5MB 이하만 업로드할 수 있어.": "È possibile caricare solo immagini fino a 5 MB.",
    "이미지는 본문 안에 [image-번호] 형태로 표시됨.": "Le immagini sono mostrate nel contenuto come [image-numero].",
    "인포 버튼 시간 설정이 올바르지 않습니다.": "Le impostazioni temporali del pulsante informativo non sono valide.",
    "인포 버튼 프리셋 수정": "Modifica preset pulsante informativo",
    "인포 버튼 프리셋 수정 실패": "Modifica preset pulsante informativo non riuscita",
    "인포메이션 버튼(선택)": "Pulsante informativo (facoltativo)",
    "인포버튼 없음": "Nessun pulsante informativo",
    "인포버튼 프리셋 수정": "Modifica preset pulsante info",
    "인포버튼 프리셋 수정 실패": "Modifica preset pulsante info non riuscita",
    "인포카드 추가": "Aggiungi scheda informativa",
    "인포카드 추가 실패": "Aggiunta scheda informativa non riuscita",
    "인포카드 타이머": "Timer scheda informativa",
    "임시": "Temporaneo",
    "임시저장": "Salva bozza",
    "자산": "Asset",
    "작성자": "Autore",
    "잠금 비밀번호": "Password di blocco",
    "재시작": "Riavvia",
    "저장 시 실제 이미지 URL 토큰으로 자동 변환됨.": "Al salvataggio viene convertito automaticamente nel token URL reale dell’immagine.",
    "저장됩니다. 기준 시간은 위 인포카드 타이머 설정(timerMode/timerEndUtc)을 사용합니다.": "Verrà salvato. L’ora di riferimento usa le impostazioni del timer della scheda informativa sopra (timerMode/timerEndUtc).",
    "저장중...": "Salvataggio...",
    "전광판": "Tabellone",
    "전광판 관리": "Gestione tabellone",
    "전광판 등록 실패": "Registrazione tabellone non riuscita",
    "전광판 목록 조회 실패": "Lettura elenco tabelloni non riuscita",
    "전광판 삭제 실패": "Eliminazione tabellone non riuscita",
    "전광판 삭제?\n(id={id})": "Eliminare il tabellone?\n(id={id})",
    "전광판 수정 실패": "Modifica tabellone non riuscita",
    "정렬 변경에 실패했어.": "Modifica ordinamento non riuscita.",
    "정렬 저장": "Salva ordinamento",
    "정렬 저장 실패": "Salvataggio ordinamento non riuscito",
    "정렬 화살표는 같은 area/device/country 묶음 안에서만 동작해.": "Le frecce di ordinamento funzionano solo nello stesso gruppo area/device/country.",
    "정상": "Normale",
    "제목을 입력해줘.": "Inserisci il titolo.",
    "조회": "Visualizza",
    "줄바꿈 그대로 표시됨.": "Le interruzioni di riga vengono mantenute.",
    "중동": "Medio Oriente",
    "중앙아시아": "Asia centrale",
    "중지(삭제)": "Interrompi (elimina)",
    "지금": "Ora",
    "지급 실패": "Pagamento non riuscito",
    "직속": "Diretto",
    "차감 실패": "Addebito non riuscito",
    "체크하지 않으면 앞으로 새로 생성되는 테이블에만 적용됩니다.": "Se non selezionato, si applicherà solo ai tavoli creati in futuro.",
    "총": "Totale",
    "총 상금풀(1.5%):": "Montepremi totale (1,5%):",
    "총베팅액:": "Puntata totale:",
    "추가": "Aggiungi",
    "크기(px)": "Dimensione (px)",
    "클릭 이동 URL(link_url)": "URL di navigazione al clic (link_url)",
    "클릭 이동 링크(URL)": "Link di navigazione al clic (URL)",
    "클릭하면 등록 모달": "Fai clic per aprire la finestra di registrazione",
    "클릭하면 표시 기준 시간이 해당 날짜로 설정됩니다": "Facendo clic, l’ora di riferimento viene impostata su quella data",
    "타이머 없음": "Nessun timer",
    "타이머 타입": "Tipo timer",
    "타이머(존재유무만)": "Timer (solo presenza)",
    "타이머는": "Il timer è",
    "타입": "Tipo",
    "테이블 그룹 목록 조회 실패": "Lettura elenco gruppi tavolo non riuscita",
    "테이블 그룹 삭제?\n({displayCode})": "Eliminare il gruppo tavoli?\n({displayCode})",
    "테이블 그룹 생성 실패": "Creazione gruppo tavoli non riuscita",
    "테이블 그룹 생성 완료": "Gruppo tavoli creato",
    "테이블 그룹 코드 생성 실패": "Creazione codice gruppo tavoli non riuscita",
    "테이블 그룹이 없습니다.": "Nessun gruppo tavoli.",
    "테이블 미션 RUN 생성 실패": "Creazione RUN missione tavolo non riuscita",
    "테이블 미션 RUN 중지 실패": "Interruzione RUN missione tavolo non riuscita",
    "테이블 미션 RUN 중지(그룹 전체 적용)?\n(display_code={displayCode})": "Interrompere il RUN della missione tavolo per tutto il gruppo?\n(display_code={displayCode})",
    "테이블 미션 cfg 저장 실패": "Salvataggio cfg missione tavolo non riuscito",
    "테이블 미션 상금 분배(프론트 계산)": "Distribuzione premio missione tavolo (calcolo frontend)",
    "테이블 미션 상태 조회 실패": "Lettura stato missione tavolo non riuscita",
    "테이블 미션 에이전트 분배 비율(agent_share) 입력 (예: 0.2 = 20%)": "Inserisci la quota agente della missione tavolo (agent_share), esempio: 0.2 = 20%",
    "테이블 미션 총 베팅금(target_total_bet)을 입력": "Inserisci la puntata totale della missione tavolo (target_total_bet)",
    "텍스트": "Testo",
    "텍스트 스타일": "Stile testo",
    "파일명": "Nome file",
    "페이지": "Pagina",
    "폴더에 저장되고, DB에는 메타/경로만 저장돼.": "Salvato nella cartella; nel DB vengono salvati solo metadati e percorso.",
    "표시 기준 시간": "Ora di riferimento visualizzazione",
    "표시 순서(order)": "Ordine di visualizzazione (order)",
    "표시 여부만": "Solo visibilità",
    "프리셋(배경/요소/URL)": "Preset (sfondo/elementi/URL)",
    "플레이어 상금풀(": "Montepremi giocatore (",
    "현재 index 값들을 서버에 저장": "Salva sul server i valori index correnti",
    "현재 활성 테이블에도 즉시 적용": "Applica subito anche ai tavoli attivi",
    "활성 RUN이 없습니다.": "Nessun RUN attivo."
  },
  "fr": {
    "%) 중 몇 %를 하위에게 분배하시겠습니까?": "%) quel pourcentage souhaitez-vous distribuer au niveau inférieur ?",
    "(password 있음)": "(mot de passe défini)",
    "(링크 없음)": "(aucun lien)",
    "(본문 없음)": "(aucun contenu)",
    "(없음)": "(aucun)",
    "(여기 클릭하면 새 공지 모달 오픈)": "(cliquez ici pour ouvrir la fenêtre de nouvelle annonce)",
    "(이름없음)": "(sans nom)",
    "(자동)": "(automatique)",
    "* index를 바꾼 뒤": "* Après avoir modifié l’index",
    "* 무한 모드일 때 UI상 “30일마다 갱신”로 표시용": "* Utilisé pour afficher « renouvelé tous les 30 jours » dans l’interface en mode infini",
    "* 예: 상위 50% 중": "* Exemple : sur les 50 % du niveau supérieur",
    "* 이 설정은 인포카드 내부 카운트다운 기준입니다. 위 시간 설정은 로비 노출 기간만 제어합니다.": "* Ce réglage sert de référence au compte à rebours de la carte d’information. Le réglage horaire ci-dessus contrôle uniquement la période d’affichage dans le lobby.",
    "* 이 스타일은 인포카드의 text 요소에만 적용됩니다. 타이머/아이콘은 기존 스타일을 유지합니다.": "* Ce style s’applique uniquement à l’élément text de la carte d’information. Le minuteur et l’icône conservent leur style actuel.",
    "* 이 시간에 “유효한(display_sets.time)” 그룹만 아래 목록에 표시": "* Seuls les groupes « valides (display_sets.time) » à cette heure sont affichés dans la liste ci-dessous",
    "* 저장은 UTC로 들어가고, 화면은 로컬 시간으로 입력/표시됨": "* L’enregistrement se fait en UTC, tandis que la saisie et l’affichage utilisent l’heure locale",
    "* 필요할 때만 추가하면 됨": "* À ajouter uniquement lorsque nécessaire",
    "* 현재 기준시간 주변(±15~45일)에 기간(range) 설정된 DisplaySet이 없습니다.": "* Aucun DisplaySet avec une période (range) n’existe autour de l’heure de référence actuelle (±15 à 45 jours).",
    "+ 공지 작성": "+ Rédiger une annonce",
    "+ 광고 등록": "+ Ajouter une publicité",
    "+ 새 공지 작성": "+ Rédiger une nouvelle annonce",
    "+ 새 광고 등록": "+ Ajouter une nouvelle publicité",
    "+ 아이콘(업로드)": "+ Icône (téléversement)",
    "+ 이미지": "+ Image",
    "+ 인포 버튼 추가": "+ Ajouter un bouton d’information",
    "+ 인포카드 추가": "+ Ajouter une carte d’information",
    "+ 타이머(표시여부)": "+ Minuteur (affichage)",
    "- PENDING 는 저장만 되고 노출되지 않음": "- PENDING est uniquement enregistré et n’est pas affiché",
    "- SCHEDULED 는 startAt 이후 자동 노출": "- SCHEDULED s’affiche automatiquement après startAt",
    "- endAt 이 지나면 자동 만료": "- Expire automatiquement après endAt",
    "/community/notice/1 또는 https://...": "/community/notice/1 ou https://...",
    "0보다 큰 숫자만 가능": "Seuls les nombres supérieurs à 0 sont autorisés",
    "DisplaySet 날짜 필터(1일 단위)": "Filtre de date DisplaySet (par jour)",
    "Due Date 지정": "Définir la date d’échéance",
    "Due Date(관리자 로컬 시간)": "Date d’échéance (heure locale de l’administrateur)",
    "Due Date를 올바른 날짜/시간으로 입력해야 합니다.": "Saisissez une date et une heure d’échéance valides.",
    "Due Date를 입력해야 합니다.": "La date d’échéance est obligatoire.",
    "RUN 생성: 미션 총 베팅금(target_total_bet) 입력": "Créer un RUN : saisir la mise totale de la mission (target_total_bet)",
    "RUN 생성: 테이블 미션 총 베팅금(target_total_bet) 입력": "Créer un RUN : saisir la mise totale de la mission de table (target_total_bet)",
    "SB/BB는 0보다 큰 숫자이며 소수점은 최대 2자리까지 입력할 수 있습니다. 예: 0.25 / 0.50": "SB/BB doivent être des nombres supérieurs à 0 avec au maximum 2 décimales. Exemple : 0.25 / 0.50",
    "USDT TRC20 테스트넷": "Réseau de test USDT TRC20",
    "agent_share는 0~1 사이 숫자만 가능 (예: 0.2)": "agent_share doit être un nombre compris entre 0 et 1 (ex. : 0.2)",
    "all / 데스크톱+모바일": "all / bureau + mobile",
    "desktop / 데스크톱": "desktop / bureau",
    "endAt (종료, 선택)": "endAt (fin, facultatif)",
    "endAt은 startAt보다 늦어야 해.": "endAt doit être postérieur à startAt.",
    "index(선택)": "index (facultatif)",
    "message는 빈값이 될 수 없습니다.": "message ne peut pas être vide.",
    "message는 필수입니다.": "message est obligatoire.",
    "mobile / 모바일": "mobile / mobile",
    "reserve_time_utc(표시:로컬)": "reserve_time_utc (affichage : local)",
    "reserve_time_utc가 지난 waiting들을 running으로 전환": "Convertir les éléments waiting dont reserve_time_utc est dépassé en running",
    "startAt (시작)": "startAt (début)",
    "status(선택)": "status (facultatif)",
    "superadmin 전용 UI (admin-server / DB 저장)": "Interface réservée au superadmin (enregistrement admin-server / DB)",
    "tick 실패": "Échec du tick",
    "{targetId} 삭제하시겠습니까?": "Supprimer {targetId} ?",
    "※ 이미지는 admin server 의": "※ Les images sont stockées sur l’admin server dans",
    "※ 입력이 없으면 0%로 처리됩니다.": "※ Sans saisie, la valeur est traitée comme 0 %.",
    "※ 입력이 없으면 0.00%로 처리됩니다.": "※ Sans saisie, la valeur est traitée comme 0,00 %.",
    "※ 현재 저장은 admin-server API를 통해 DB에 반영됨.": "※ L’enregistrement actuel est appliqué à la DB via l’API admin-server.",
    "→ 하위는": "→ Le niveau inférieur reçoit",
    "같은 area라도 device/country가 다르면 각각 별도 row로 저장돼.": "Même avec la même area, chaque combinaison device/country est enregistrée dans une ligne distincte.",
    "갱신 주기(일)": "Cycle de renouvellement (jours)",
    "갱신 중": "Renouvellement en cours",
    "검색: 이름/링크/국가": "Rechercher : nom/lien/pays",
    "검색: 제목/본문/작성자": "Rechercher : titre/contenu/auteur",
    "공지 목록 불러오는 중...": "Chargement de la liste des annonces...",
    "공지 목록을 불러오지 못했어.\n{message}": "Impossible de charger la liste des annonces.\n{message}",
    "공지 삭제에 실패했어.\n{message}": "Échec de la suppression de l’annonce.\n{message}",
    "공지 삭제할까?\n\n- {title}": "Supprimer cette annonce ?\n\n- {title}",
    "공지 저장에 실패했어.\n{message}": "Échec de l’enregistrement de l’annonce.\n{message}",
    "공지가 없어. 위에서 새로 작성해줘.": "Aucune annonce. Créez-en une ci-dessus.",
    "광고 목록 불러오는 중...": "Chargement de la liste des publicités...",
    "광고 목록을 불러오지 못했어.": "Impossible de charger la liste des publicités.",
    "광고 삭제에 실패했어.": "Échec de la suppression de la publicité.",
    "광고 이미지를 업로드해줘.": "Téléversez une image publicitaire.",
    "광고 저장에 실패했어.": "Échec de l’enregistrement de la publicité.",
    "광고를 삭제할까?\n\n- {label}": "Supprimer cette publicité ?\n\n- {label}",
    "구분": "Catégorie",
    "국가(country)를 입력해줘. 예: KR / US / JP / ALL": "Saisissez le pays (country). Exemple : KR / US / JP / ALL",
    "그룹 미션": "Mission de groupe",
    "그룹 미션 RUN 중지?\nrun_id={runId}": "Arrêter le RUN de mission de groupe ?\nrun_id={runId}",
    "그룹 미션 설정": "Paramètres de mission de groupe",
    "그룹 미션 시작": "Démarrer la mission de groupe",
    "그룹 미션 중지 실패 (백엔드에 DELETE /admin/mission/run/:run_id 필요)": "Échec de l’arrêt de la mission de groupe (DELETE /admin/mission/run/:run_id requis côté backend)",
    "그룹 시간 설정이 올바르지 않습니다.": "Le réglage horaire du groupe n’est pas valide.",
    "그룹 이름, Small Blind, Big Blind는 필수 입력입니다. SB/BB는 예: 0.25, 0.50처럼 입력할 수 있습니다.": "Le nom du groupe, Small Blind et Big Blind sont obligatoires. SB/BB peuvent être saisis comme 0.25 et 0.50.",
    "그룹은 삭제됐지만 Redis 정리가 실패했습니다. (code={code})": "Le groupe a été supprimé, mais le nettoyage Redis a échoué. (code={code})",
    "글로벌": "Global",
    "내부용 이름(label)": "Nom interne (label)",
    "내부용 이름(label)을 입력해줘.": "Saisissez le nom interne (label).",
    "노출": "Affichage",
    "노출(즉시/기간무관)": "Afficher (immédiatement/sans tenir compte de la période)",
    "노출중": "En cours d’affichage",
    "닉네임": "Pseudo",
    "대상": "Cible",
    "데스크톱": "Bureau",
    "등록": "Enregistrer",
    "등록된 광고가 없어.": "Aucune publicité enregistrée.",
    "등록된 이미지 없음": "Aucune image enregistrée",
    "라운지 포인트 %": "% de points lounge",
    "라운지 포인트 % (0~100)": "% de points lounge (0 à 100)",
    "라운지 포인트 %는 0~100 사이 숫자이며 소수점은 최대 2자리까지 가능합니다.": "Le % de points lounge doit être compris entre 0 et 100, avec au maximum 2 décimales.",
    "레이크백": "Rakeback",
    "링크:": "Lien :",
    "링크는 http:// 또는 https:// 로 시작해야 해.": "Le lien doit commencer par http:// ou https://.",
    "메모": "Note",
    "메인 영역": "Zone principale",
    "모바일": "Mobile",
    "무한(infinite) 항목(상시 노출)": "Élément infini (infinite, affichage permanent)",
    "무한(약 {days}일 단위 갱신)": "Infini (renouvellement environ tous les {days} jours)",
    "미션 RUN 생성 실패": "Échec de la création du RUN de mission",
    "미션 cfg 저장 실패": "Échec de l’enregistrement de la configuration de mission",
    "미션 상금 분배(프론트 계산)": "Répartition de la cagnotte de mission (calcul côté frontend)",
    "미션 상태 조회 실패": "Échec de la consultation de l’état de la mission",
    "미션 총 베팅금(target_total_bet)을 입력": "Saisissez la mise totale de la mission (target_total_bet)",
    "미입력시 자동": "Automatique si laissé vide",
    "배치": "Lot",
    "백엔드에 종료 API가 있어야 실제 중지됨": "Une API de terminaison côté backend est nécessaire pour un arrêt réel",
    "본문을 입력해줘.": "Saisissez le contenu.",
    "비밀번호": "Mot de passe",
    "비워두면 클릭 이동 없음": "Laissez vide pour désactiver la redirection au clic",
    "상단 고정(📌)": "Épingler en haut (📌)",
    "상위 에이전트의 수수료(": "Commission de l’agent supérieur (",
    "상태 보기 (테이블 미션 raw)": "Voir l’état (données brutes de la mission de table)",
    "새 전광판 등록": "Ajouter un nouveau panneau",
    "생성 에러:": "Erreur de création :",
    "서버로 전송될 preset 문자열(콤마 구분)": "Chaîne preset envoyée au serveur (séparée par des virgules)",
    "수정(설정)": "Modifier (paramètres)",
    "시간 설정": "Réglage horaire",
    "시간 설정이 올바르지 않습니다.": "Le réglage horaire n’est pas valide.",
    "시작(생성)": "Démarrer (créer)",
    "아이디": "Identifiant",
    "아이콘 업로드 실패 (서버 업로드 API 확인 필요)": "Échec du téléversement de l’icône (vérifiez l’API de téléversement du serveur)",
    "아이콘 파일은 1MB 이하로 올려주세요.": "L’icône doit faire 1 Mo ou moins.",
    "아이콘(로컬 업로드/URL)": "Icône (téléversement local/URL)",
    "아프리카": "Afrique",
    "업로드 URL을 받지 못했어.": "Aucune URL de téléversement reçue.",
    "업로드하면 /uploads/... 로 자동 입력됨 (또는 URL 직접 입력)": "Après téléversement, /uploads/... est saisi automatiquement (ou saisissez directement une URL)",
    "에이전트": "Agent",
    "에이전트 분배 비율(agent_share) 입력 (예: 0.2 = 20%)": "Saisissez le taux de répartition de l’agent (agent_share), ex. : 0.2 = 20 %",
    "에이전트 상금풀(": "Cagnotte de l’agent (",
    "예: HOT": "Ex. : HOT",
    "예: KR / US / JP / ALL": "Ex. : KR / US / JP / ALL",
    "예: NEW YEAR EVENT START!": "Ex. : NEW YEAR EVENT START!",
    "예: VIP NLH 1/2": "Ex. : VIP NLH 1/2",
    "예: 메인 KR 모바일 상단 배너": "Ex. : bannière supérieure mobile principale KR",
    "예: 오늘만 레이크 0%": "Ex. : rake à 0 % aujourd’hui seulement",
    "예: 🔥 12/31 이벤트 진행중": "Ex. : 🔥 Événement du 31/12 en cours",
    "예: 🔧HOT": "Ex. : 🔧HOT",
    "예약 tick": "Tick de réservation",
    "예약 보류": "Réservation en attente",
    "예약 사용": "Utiliser la réservation",
    "예약 상태면 startAt(시작일시)를 넣어줘.": "En statut réservé, saisissez startAt (date/heure de début).",
    "예약 시간이 올바르지 않습니다.": "L’heure de réservation n’est pas valide.",
    "예약 없음 → 즉시 진행(running)으로 자동 설정됨": "Aucune réservation → statut running défini automatiquement et immédiatement",
    "예약(reserve_time_utc)": "Réservation (reserve_time_utc)",
    "예약/상태": "Réservation/état",
    "예약보류": "Réservation suspendue",
    "왼쪽에서 공지를 선택해줘.": "Sélectionnez une annonce à gauche.",
    "왼쪽에서 광고를 선택해줘.": "Sélectionnez une publicité à gauche.",
    "요소(최대 4개)": "Éléments (4 maximum)",
    "요청 실패 ({status})": "Échec de la requête ({status})",
    "용량": "Taille",
    "유럽": "Europe",
    "유효 인포메이션 버튼:": "Boutons d’information valides :",
    "을 눌러야 서버에 반영됨": "doit être cliqué pour appliquer les changements au serveur",
    "이동 URL": "URL de destination",
    "이메일": "E-mail",
    "이미 테이블 미션 RUN이 실행 중입니다.\n(run_id={runId})\n재시작(기존 RUN 삭제 후 새로 생성)할까요?": "Un RUN de mission de table est déjà en cours.\n(run_id={runId})\nRedémarrer en supprimant le RUN existant puis en en créant un nouveau ?",
    "이미지": "Image",
    "이미지 넣기": "Insérer une image",
    "이미지 업로드 실패: {message}": "Échec du téléversement de l’image : {message}",
    "이미지 업로드중...": "Téléversement de l’image...",
    "이미지 없음": "Aucune image",
    "이미지 열기": "Ouvrir l’image",
    "이미지 파일만 등록할 수 있어.": "Seuls les fichiers image peuvent être enregistrés.",
    "이미지 파일만 업로드할 수 있어.": "Seuls les fichiers image peuvent être téléversés.",
    "이미지(URL)": "Image (URL)",
    "이미지는 5MB 이하만 업로드할 수 있어.": "Seules les images de 5 Mo ou moins peuvent être téléversées.",
    "이미지는 본문 안에 [image-번호] 형태로 표시됨.": "Les images apparaissent dans le contenu sous la forme [image-numéro].",
    "인포 버튼 시간 설정이 올바르지 않습니다.": "Le réglage horaire du bouton d’information n’est pas valide.",
    "인포 버튼 프리셋 수정": "Modifier le preset du bouton d’information",
    "인포 버튼 프리셋 수정 실패": "Échec de la modification du preset du bouton d’information",
    "인포메이션 버튼(선택)": "Bouton d’information (facultatif)",
    "인포버튼 없음": "Aucun bouton d’information",
    "인포버튼 프리셋 수정": "Modifier le preset du bouton d’information",
    "인포버튼 프리셋 수정 실패": "Échec de la modification du preset du bouton d’information",
    "인포카드 추가": "Ajouter une carte d’information",
    "인포카드 추가 실패": "Échec de l’ajout de la carte d’information",
    "인포카드 타이머": "Minuteur de carte d’information",
    "임시": "Temporaire",
    "임시저장": "Enregistrement temporaire",
    "자산": "Actifs",
    "작성자": "Auteur",
    "잠금 비밀번호": "Mot de passe de verrouillage",
    "재시작": "Redémarrer",
    "저장 시 실제 이미지 URL 토큰으로 자동 변환됨.": "Lors de l’enregistrement, la valeur est automatiquement convertie en jeton d’URL d’image réel.",
    "저장됩니다. 기준 시간은 위 인포카드 타이머 설정(timerMode/timerEndUtc)을 사용합니다.": "Enregistré. L’heure de référence utilise le réglage du minuteur de la carte d’information ci-dessus (timerMode/timerEndUtc).",
    "저장중...": "Enregistrement...",
    "전광판": "Panneau",
    "전광판 관리": "Gestion des panneaux",
    "전광판 등록 실패": "Échec de l’enregistrement du panneau",
    "전광판 목록 조회 실패": "Échec du chargement de la liste des panneaux",
    "전광판 삭제 실패": "Échec de la suppression du panneau",
    "전광판 삭제?\n(id={id})": "Supprimer le panneau ?\n(id={id})",
    "전광판 수정 실패": "Échec de la modification du panneau",
    "정렬 변경에 실패했어.": "Échec de la modification de l’ordre.",
    "정렬 저장": "Enregistrer l’ordre",
    "정렬 저장 실패": "Échec de l’enregistrement de l’ordre",
    "정렬 화살표는 같은 area/device/country 묶음 안에서만 동작해.": "Les flèches de tri fonctionnent uniquement dans le même groupe area/device/country.",
    "정상": "Normal",
    "제목을 입력해줘.": "Saisissez un titre.",
    "조회": "Consulter",
    "줄바꿈 그대로 표시됨.": "Les sauts de ligne sont affichés tels quels.",
    "중동": "Moyen-Orient",
    "중앙아시아": "Asie centrale",
    "중지(삭제)": "Arrêter (supprimer)",
    "지금": "Maintenant",
    "지급 실패": "Échec du paiement",
    "직속": "Direct",
    "차감 실패": "Échec du débit",
    "체크하지 않으면 앞으로 새로 생성되는 테이블에만 적용됩니다.": "Si cette option n’est pas cochée, le réglage s’appliquera uniquement aux nouvelles tables créées à l’avenir.",
    "총": "Total",
    "총 상금풀(1.5%):": "Cagnotte totale (1,5 %) :",
    "총베팅액:": "Mise totale :",
    "추가": "Ajouter",
    "크기(px)": "Taille (px)",
    "클릭 이동 URL(link_url)": "URL de destination au clic (link_url)",
    "클릭 이동 링크(URL)": "Lien de destination au clic (URL)",
    "클릭하면 등록 모달": "Cliquer pour ouvrir la fenêtre d’enregistrement",
    "클릭하면 표시 기준 시간이 해당 날짜로 설정됩니다": "Cliquer pour définir l’heure de référence d’affichage sur cette date",
    "타이머 없음": "Aucun minuteur",
    "타이머 타입": "Type de minuteur",
    "타이머(존재유무만)": "Minuteur (présence uniquement)",
    "타이머는": "Le minuteur",
    "타입": "Type",
    "테이블 그룹 목록 조회 실패": "Échec du chargement de la liste des groupes de tables",
    "테이블 그룹 삭제?\n({displayCode})": "Supprimer le groupe de tables ?\n({displayCode})",
    "테이블 그룹 생성 실패": "Échec de la création du groupe de tables",
    "테이블 그룹 생성 완료": "Groupe de tables créé",
    "테이블 그룹 코드 생성 실패": "Échec de la création du code de groupe de tables",
    "테이블 그룹이 없습니다.": "Aucun groupe de tables.",
    "테이블 미션 RUN 생성 실패": "Échec de la création du RUN de mission de table",
    "테이블 미션 RUN 중지 실패": "Échec de l’arrêt du RUN de mission de table",
    "테이블 미션 RUN 중지(그룹 전체 적용)?\n(display_code={displayCode})": "Arrêter le RUN de mission de table (appliquer à tout le groupe) ?\n(display_code={displayCode})",
    "테이블 미션 cfg 저장 실패": "Échec de l’enregistrement de la configuration de mission de table",
    "테이블 미션 상금 분배(프론트 계산)": "Répartition de la cagnotte de mission de table (calcul côté frontend)",
    "테이블 미션 상태 조회 실패": "Échec de la consultation de l’état de la mission de table",
    "테이블 미션 에이전트 분배 비율(agent_share) 입력 (예: 0.2 = 20%)": "Saisissez le taux de répartition agent de la mission de table (agent_share), ex. : 0.2 = 20 %",
    "테이블 미션 총 베팅금(target_total_bet)을 입력": "Saisissez la mise totale de la mission de table (target_total_bet)",
    "텍스트": "Texte",
    "텍스트 스타일": "Style du texte",
    "파일명": "Nom du fichier",
    "페이지": "Page",
    "폴더에 저장되고, DB에는 메타/경로만 저장돼.": "Enregistré dans le dossier ; seules les métadonnées et le chemin sont enregistrés dans la DB.",
    "표시 기준 시간": "Heure de référence d’affichage",
    "표시 순서(order)": "Ordre d’affichage (order)",
    "표시 여부만": "Visibilité uniquement",
    "프리셋(배경/요소/URL)": "Preset (arrière-plan/éléments/URL)",
    "플레이어 상금풀(": "Cagnotte des joueurs (",
    "현재 index 값들을 서버에 저장": "Enregistrer les valeurs index actuelles sur le serveur",
    "현재 활성 테이블에도 즉시 적용": "Appliquer immédiatement aux tables actives",
    "활성 RUN이 없습니다.": "Aucun RUN actif."
  },
  "hi": {
    "%) 중 몇 %를 하위에게 분배하시겠습니까?": "%) में से कितने प्रतिशत नीचे के स्तर को वितरित करना है?",
    "(password 있음)": "(पासवर्ड सेट है)",
    "(링크 없음)": "(कोई लिंक नहीं)",
    "(본문 없음)": "(कोई मुख्य सामग्री नहीं)",
    "(없음)": "(कोई नहीं)",
    "(여기 클릭하면 새 공지 모달 오픈)": "(नई सूचना विंडो खोलने के लिए यहां क्लिक करें)",
    "(이름없음)": "(बिना नाम)",
    "(자동)": "(स्वचालित)",
    "* index를 바꾼 뒤": "* index बदलने के बाद",
    "* 무한 모드일 때 UI상 “30일마다 갱신”로 표시용": "* अनंत मोड में UI पर ‘हर 30 दिन में नवीनीकरण’ दिखाने के लिए",
    "* 예: 상위 50% 중": "* उदाहरण: ऊपर के 50% में से",
    "* 이 설정은 인포카드 내부 카운트다운 기준입니다. 위 시간 설정은 로비 노출 기간만 제어합니다.": "* यह सेटिंग इन्फो कार्ड के अंदर काउंटडाउन का आधार है। ऊपर की समय सेटिंग केवल लॉबी में दिखने की अवधि नियंत्रित करती है।",
    "* 이 스타일은 인포카드의 text 요소에만 적용됩니다. 타이머/아이콘은 기존 스타일을 유지합니다.": "* यह शैली केवल इन्फो कार्ड के text तत्व पर लागू होती है। टाइमर/आइकन अपनी मौजूदा शैली बनाए रखते हैं।",
    "* 이 시간에 “유효한(display_sets.time)” 그룹만 아래 목록에 표시": "* इस समय केवल ‘मान्य (display_sets.time)’ समूह नीचे की सूची में दिखाए जाते हैं",
    "* 저장은 UTC로 들어가고, 화면은 로컬 시간으로 입력/표시됨": "* सेव UTC में होता है, जबकि स्क्रीन पर इनपुट/डिस्प्ले स्थानीय समय में होता है",
    "* 필요할 때만 추가하면 됨": "* केवल आवश्यकता होने पर जोड़ें",
    "* 현재 기준시간 주변(±15~45일)에 기간(range) 설정된 DisplaySet이 없습니다.": "* वर्तमान संदर्भ समय के आसपास (±15–45 दिन) अवधि (range) वाला कोई DisplaySet नहीं है।",
    "+ 공지 작성": "+ सूचना लिखें",
    "+ 광고 등록": "+ विज्ञापन जोड़ें",
    "+ 새 공지 작성": "+ नई सूचना लिखें",
    "+ 새 광고 등록": "+ नया विज्ञापन जोड़ें",
    "+ 아이콘(업로드)": "+ आइकन (अपलोड)",
    "+ 이미지": "+ छवि",
    "+ 인포 버튼 추가": "+ इन्फो बटन जोड़ें",
    "+ 인포카드 추가": "+ इन्फो कार्ड जोड़ें",
    "+ 타이머(표시여부)": "+ टाइमर (दिखाना है या नहीं)",
    "- PENDING 는 저장만 되고 노출되지 않음": "- PENDING केवल सेव होता है और प्रदर्शित नहीं होता",
    "- SCHEDULED 는 startAt 이후 자동 노출": "- SCHEDULED, startAt के बाद अपने आप प्रदर्शित होता है",
    "- endAt 이 지나면 자동 만료": "- endAt बीतने पर अपने आप समाप्त हो जाता है",
    "/community/notice/1 또는 https://...": "/community/notice/1 या https://...",
    "0보다 큰 숫자만 가능": "केवल 0 से बड़ी संख्या मान्य है",
    "DisplaySet 날짜 필터(1일 단위)": "DisplaySet दिनांक फ़िल्टर (1 दिन इकाई)",
    "Due Date 지정": "Due Date निर्धारित करें",
    "Due Date(관리자 로컬 시간)": "Due Date (एडमिन का स्थानीय समय)",
    "Due Date를 올바른 날짜/시간으로 입력해야 합니다.": "सही Due Date और समय दर्ज करें।",
    "Due Date를 입력해야 합니다.": "Due Date दर्ज करना आवश्यक है।",
    "RUN 생성: 미션 총 베팅금(target_total_bet) 입력": "RUN बनाएं: मिशन की कुल बेट राशि (target_total_bet) दर्ज करें",
    "RUN 생성: 테이블 미션 총 베팅금(target_total_bet) 입력": "RUN बनाएं: टेबल मिशन की कुल बेट राशि (target_total_bet) दर्ज करें",
    "SB/BB는 0보다 큰 숫자이며 소수점은 최대 2자리까지 입력할 수 있습니다. 예: 0.25 / 0.50": "SB/BB को 0 से बड़ी संख्या होना चाहिए और अधिकतम 2 दशमलव स्थान तक दर्ज किया जा सकता है। उदाहरण: 0.25 / 0.50",
    "USDT TRC20 테스트넷": "USDT TRC20 टेस्टनेट",
    "agent_share는 0~1 사이 숫자만 가능 (예: 0.2)": "agent_share केवल 0 से 1 के बीच की संख्या हो सकती है (उदा.: 0.2)",
    "all / 데스크톱+모바일": "all / डेस्कटॉप + मोबाइल",
    "desktop / 데스크톱": "desktop / डेस्कटॉप",
    "endAt (종료, 선택)": "endAt (समाप्ति, वैकल्पिक)",
    "endAt은 startAt보다 늦어야 해.": "endAt, startAt से बाद का होना चाहिए।",
    "index(선택)": "index (वैकल्पिक)",
    "message는 빈값이 될 수 없습니다.": "message खाली नहीं हो सकता।",
    "message는 필수입니다.": "message आवश्यक है।",
    "mobile / 모바일": "mobile / मोबाइल",
    "reserve_time_utc(표시:로컬)": "reserve_time_utc (प्रदर्शन: स्थानीय)",
    "reserve_time_utc가 지난 waiting들을 running으로 전환": "जिन waiting आइटम का reserve_time_utc बीत गया है उन्हें running में बदलें",
    "startAt (시작)": "startAt (आरंभ)",
    "status(선택)": "status (वैकल्पिक)",
    "superadmin 전용 UI (admin-server / DB 저장)": "केवल superadmin UI (admin-server / DB में सेव)",
    "tick 실패": "tick विफल",
    "{targetId} 삭제하시겠습니까?": "क्या {targetId} हटाना है?",
    "※ 이미지는 admin server 의": "※ छवियां admin server के",
    "※ 입력이 없으면 0%로 처리됩니다.": "※ इनपुट न होने पर इसे 0% माना जाएगा।",
    "※ 입력이 없으면 0.00%로 처리됩니다.": "※ इनपुट न होने पर इसे 0.00% माना जाएगा।",
    "※ 현재 저장은 admin-server API를 통해 DB에 반영됨.": "※ वर्तमान सेव admin-server API के माध्यम से DB में लागू होता है।",
    "→ 하위는": "→ निचले स्तर को",
    "같은 area라도 device/country가 다르면 각각 별도 row로 저장돼.": "area समान होने पर भी device/country अलग हो तो हर संयोजन अलग row में सेव होता है।",
    "갱신 주기(일)": "नवीनीकरण चक्र (दिन)",
    "갱신 중": "नवीनीकरण जारी है",
    "검색: 이름/링크/국가": "खोजें: नाम/लिंक/देश",
    "검색: 제목/본문/작성자": "खोजें: शीर्षक/सामग्री/लेखक",
    "공지 목록 불러오는 중...": "सूचना सूची लोड हो रही है...",
    "공지 목록을 불러오지 못했어.\n{message}": "सूचना सूची लोड नहीं हो सकी।\n{message}",
    "공지 삭제에 실패했어.\n{message}": "सूचना हटाने में विफल।\n{message}",
    "공지 삭제할까?\n\n- {title}": "क्या यह सूचना हटानी है?\n\n- {title}",
    "공지 저장에 실패했어.\n{message}": "सूचना सेव करने में विफल।\n{message}",
    "공지가 없어. 위에서 새로 작성해줘.": "कोई सूचना नहीं है। ऊपर से नई सूचना बनाएं।",
    "광고 목록 불러오는 중...": "विज्ञापन सूची लोड हो रही है...",
    "광고 목록을 불러오지 못했어.": "विज्ञापन सूची लोड नहीं हो सकी।",
    "광고 삭제에 실패했어.": "विज्ञापन हटाने में विफल।",
    "광고 이미지를 업로드해줘.": "विज्ञापन की छवि अपलोड करें।",
    "광고 저장에 실패했어.": "विज्ञापन सेव करने में विफल।",
    "광고를 삭제할까?\n\n- {label}": "क्या यह विज्ञापन हटाना है?\n\n- {label}",
    "구분": "श्रेणी",
    "국가(country)를 입력해줘. 예: KR / US / JP / ALL": "देश (country) दर्ज करें। उदाहरण: KR / US / JP / ALL",
    "그룹 미션": "समूह मिशन",
    "그룹 미션 RUN 중지?\nrun_id={runId}": "समूह मिशन RUN रोकना है?\nrun_id={runId}",
    "그룹 미션 설정": "समूह मिशन सेटिंग",
    "그룹 미션 시작": "समूह मिशन शुरू करें",
    "그룹 미션 중지 실패 (백엔드에 DELETE /admin/mission/run/:run_id 필요)": "समूह मिशन रोकने में विफल (backend में DELETE /admin/mission/run/:run_id आवश्यक)",
    "그룹 시간 설정이 올바르지 않습니다.": "समूह समय सेटिंग मान्य नहीं है।",
    "그룹 이름, Small Blind, Big Blind는 필수 입력입니다. SB/BB는 예: 0.25, 0.50처럼 입력할 수 있습니다.": "समूह नाम, Small Blind और Big Blind आवश्यक हैं। SB/BB को 0.25, 0.50 जैसे दर्ज किया जा सकता है।",
    "그룹은 삭제됐지만 Redis 정리가 실패했습니다. (code={code})": "समूह हट गया, लेकिन Redis सफाई विफल रही। (code={code})",
    "글로벌": "वैश्विक",
    "내부용 이름(label)": "आंतरिक नाम (label)",
    "내부용 이름(label)을 입력해줘.": "आंतरिक नाम (label) दर्ज करें।",
    "노출": "प्रदर्शन",
    "노출(즉시/기간무관)": "दिखाएं (तुरंत/अवधि की परवाह किए बिना)",
    "노출중": "प्रदर्शित हो रहा है",
    "닉네임": "उपनाम",
    "대상": "लक्ष्य",
    "데스크톱": "डेस्कटॉप",
    "등록": "पंजीकृत करें",
    "등록된 광고가 없어.": "कोई विज्ञापन पंजीकृत नहीं है।",
    "등록된 이미지 없음": "कोई छवि पंजीकृत नहीं है",
    "라운지 포인트 %": "लाउंज पॉइंट %",
    "라운지 포인트 % (0~100)": "लाउंज पॉइंट % (0–100)",
    "라운지 포인트 %는 0~100 사이 숫자이며 소수점은 최대 2자리까지 가능합니다.": "लाउंज पॉइंट % को 0 से 100 के बीच होना चाहिए और अधिकतम 2 दशमलव स्थान तक हो सकता है।",
    "레이크백": "रेकबैक",
    "링크:": "लिंक:",
    "링크는 http:// 또는 https:// 로 시작해야 해.": "लिंक http:// या https:// से शुरू होना चाहिए।",
    "메모": "नोट",
    "메인 영역": "मुख्य क्षेत्र",
    "모바일": "मोबाइल",
    "무한(infinite) 항목(상시 노출)": "अनंत (infinite) आइटम (हमेशा प्रदर्शित)",
    "무한(약 {days}일 단위 갱신)": "अनंत (लगभग हर {days} दिन में नवीनीकरण)",
    "미션 RUN 생성 실패": "मिशन RUN बनाने में विफल",
    "미션 cfg 저장 실패": "मिशन cfg सेव करने में विफल",
    "미션 상금 분배(프론트 계산)": "मिशन पुरस्कार पूल वितरण (frontend गणना)",
    "미션 상태 조회 실패": "मिशन स्थिति प्राप्त करने में विफल",
    "미션 총 베팅금(target_total_bet)을 입력": "मिशन की कुल बेट राशि (target_total_bet) दर्ज करें",
    "미입력시 자동": "खाली होने पर स्वचालित",
    "배치": "बैच",
    "백엔드에 종료 API가 있어야 실제 중지됨": "वास्तव में रोकने के लिए backend पर समाप्ति API आवश्यक है",
    "본문을 입력해줘.": "मुख्य सामग्री दर्ज करें।",
    "비밀번호": "पासवर्ड",
    "비워두면 클릭 이동 없음": "क्लिक पर कहीं न जाने के लिए खाली छोड़ें",
    "상단 고정(📌)": "ऊपर पिन करें (📌)",
    "상위 에이전트의 수수료(": "ऊपरी एजेंट का कमीशन (",
    "상태 보기 (테이블 미션 raw)": "स्थिति देखें (टेबल मिशन raw डेटा)",
    "새 전광판 등록": "नया डिस्प्ले बोर्ड जोड़ें",
    "생성 에러:": "निर्माण त्रुटि:",
    "서버로 전송될 preset 문자열(콤마 구분)": "सर्वर को भेजी जाने वाली preset स्ट्रिंग (कॉमा से अलग)",
    "수정(설정)": "संपादित करें (सेटिंग)",
    "시간 설정": "समय सेटिंग",
    "시간 설정이 올바르지 않습니다.": "समय सेटिंग मान्य नहीं है।",
    "시작(생성)": "शुरू करें (बनाएं)",
    "아이디": "आईडी",
    "아이콘 업로드 실패 (서버 업로드 API 확인 필요)": "आइकन अपलोड विफल (सर्वर अपलोड API जांचें)",
    "아이콘 파일은 1MB 이하로 올려주세요.": "आइकन फ़ाइल 1MB या उससे कम होनी चाहिए।",
    "아이콘(로컬 업로드/URL)": "आइकन (स्थानीय अपलोड/URL)",
    "아프리카": "अफ्रीका",
    "업로드 URL을 받지 못했어.": "अपलोड URL प्राप्त नहीं हुआ।",
    "업로드하면 /uploads/... 로 자동 입력됨 (또는 URL 직접 입력)": "अपलोड करने पर /uploads/... अपने आप भर जाएगा (या सीधे URL दर्ज करें)",
    "에이전트": "एजेंट",
    "에이전트 분배 비율(agent_share) 입력 (예: 0.2 = 20%)": "एजेंट वितरण अनुपात (agent_share) दर्ज करें (उदा.: 0.2 = 20%)",
    "에이전트 상금풀(": "एजेंट पुरस्कार पूल (",
    "예: HOT": "उदा.: HOT",
    "예: KR / US / JP / ALL": "उदा.: KR / US / JP / ALL",
    "예: NEW YEAR EVENT START!": "उदा.: NEW YEAR EVENT START!",
    "예: VIP NLH 1/2": "उदा.: VIP NLH 1/2",
    "예: 메인 KR 모바일 상단 배너": "उदा.: मुख्य KR मोबाइल शीर्ष बैनर",
    "예: 오늘만 레이크 0%": "उदा.: केवल आज रेक 0%",
    "예: 🔥 12/31 이벤트 진행중": "उदा.: 🔥 12/31 इवेंट जारी है",
    "예: 🔧HOT": "उदा.: 🔧HOT",
    "예약 tick": "आरक्षण tick",
    "예약 보류": "आरक्षण लंबित",
    "예약 사용": "आरक्षण उपयोग करें",
    "예약 상태면 startAt(시작일시)를 넣어줘.": "आरक्षित स्थिति में startAt (आरंभ दिनांक/समय) दर्ज करें।",
    "예약 시간이 올바르지 않습니다.": "आरक्षण समय मान्य नहीं है।",
    "예약 없음 → 즉시 진행(running)으로 자동 설정됨": "आरक्षण नहीं → तुरंत running स्थिति अपने आप सेट होती है",
    "예약(reserve_time_utc)": "आरक्षण (reserve_time_utc)",
    "예약/상태": "आरक्षण/स्थिति",
    "예약보류": "आरक्षण रोका गया",
    "왼쪽에서 공지를 선택해줘.": "बाईं ओर से सूचना चुनें।",
    "왼쪽에서 광고를 선택해줘.": "बाईं ओर से विज्ञापन चुनें।",
    "요소(최대 4개)": "तत्व (अधिकतम 4)",
    "요청 실패 ({status})": "अनुरोध विफल ({status})",
    "용량": "आकार",
    "유럽": "यूरोप",
    "유효 인포메이션 버튼:": "मान्य इन्फो बटन:",
    "을 눌러야 서버에 반영됨": "सर्वर पर लागू करने के लिए इसे क्लिक करना आवश्यक है",
    "이동 URL": "गंतव्य URL",
    "이메일": "ईमेल",
    "이미 테이블 미션 RUN이 실행 중입니다.\n(run_id={runId})\n재시작(기존 RUN 삭제 후 새로 생성)할까요?": "टेबल मिशन RUN पहले से चल रहा है।\n(run_id={runId})\nक्या मौजूदा RUN हटाकर नया बनाते हुए पुनः शुरू करना है?",
    "이미지": "छवि",
    "이미지 넣기": "छवि डालें",
    "이미지 업로드 실패: {message}": "छवि अपलोड विफल: {message}",
    "이미지 업로드중...": "छवि अपलोड हो रही है...",
    "이미지 없음": "कोई छवि नहीं",
    "이미지 열기": "छवि खोलें",
    "이미지 파일만 등록할 수 있어.": "केवल छवि फ़ाइल पंजीकृत की जा सकती है।",
    "이미지 파일만 업로드할 수 있어.": "केवल छवि फ़ाइल अपलोड की जा सकती है।",
    "이미지(URL)": "छवि (URL)",
    "이미지는 5MB 이하만 업로드할 수 있어.": "केवल 5MB या उससे कम की छवियां अपलोड की जा सकती हैं।",
    "이미지는 본문 안에 [image-번호] 형태로 표시됨.": "छवियां मुख्य सामग्री में [image-नंबर] के रूप में दिखाई जाती हैं।",
    "인포 버튼 시간 설정이 올바르지 않습니다.": "इन्फो बटन समय सेटिंग मान्य नहीं है।",
    "인포 버튼 프리셋 수정": "इन्फो बटन preset संपादित करें",
    "인포 버튼 프리셋 수정 실패": "इन्फो बटन preset संपादन विफल",
    "인포메이션 버튼(선택)": "इन्फो बटन (वैकल्पिक)",
    "인포버튼 없음": "कोई इन्फो बटन नहीं",
    "인포버튼 프리셋 수정": "इन्फो बटन preset संपादित करें",
    "인포버튼 프리셋 수정 실패": "इन्फो बटन preset संपादन विफल",
    "인포카드 추가": "इन्फो कार्ड जोड़ें",
    "인포카드 추가 실패": "इन्फो कार्ड जोड़ने में विफल",
    "인포카드 타이머": "इन्फो कार्ड टाइमर",
    "임시": "अस्थायी",
    "임시저장": "ड्राफ्ट सेव",
    "자산": "संपत्ति",
    "작성자": "लेखक",
    "잠금 비밀번호": "लॉक पासवर्ड",
    "재시작": "पुनः शुरू करें",
    "저장 시 실제 이미지 URL 토큰으로 자동 변환됨.": "सेव करते समय यह अपने आप वास्तविक छवि URL टोकन में बदल जाता है।",
    "저장됩니다. 기준 시간은 위 인포카드 타이머 설정(timerMode/timerEndUtc)을 사용합니다.": "सेव किया जाएगा। संदर्भ समय ऊपर की इन्फो कार्ड टाइमर सेटिंग (timerMode/timerEndUtc) का उपयोग करता है।",
    "저장중...": "सेव हो रहा है...",
    "전광판": "डिस्प्ले बोर्ड",
    "전광판 관리": "डिस्प्ले बोर्ड प्रबंधन",
    "전광판 등록 실패": "डिस्प्ले बोर्ड पंजीकरण विफल",
    "전광판 목록 조회 실패": "डिस्प्ले बोर्ड सूची प्राप्त करने में विफल",
    "전광판 삭제 실패": "डिस्प्ले बोर्ड हटाने में विफल",
    "전광판 삭제?\n(id={id})": "डिस्प्ले बोर्ड हटाना है?\n(id={id})",
    "전광판 수정 실패": "डिस्प्ले बोर्ड संपादन विफल",
    "정렬 변경에 실패했어.": "क्रम बदलने में विफल।",
    "정렬 저장": "क्रम सेव करें",
    "정렬 저장 실패": "क्रम सेव करने में विफल",
    "정렬 화살표는 같은 area/device/country 묶음 안에서만 동작해.": "क्रम तीर केवल समान area/device/country समूह के भीतर काम करते हैं।",
    "정상": "सामान्य",
    "제목을 입력해줘.": "शीर्षक दर्ज करें।",
    "조회": "देखें",
    "줄바꿈 그대로 표시됨.": "लाइन ब्रेक वैसे ही दिखाए जाते हैं।",
    "중동": "मध्य पूर्व",
    "중앙아시아": "मध्य एशिया",
    "중지(삭제)": "रोकें (हटाएं)",
    "지금": "अभी",
    "지급 실패": "भुगतान विफल",
    "직속": "प्रत्यक्ष",
    "차감 실패": "कटौती विफल",
    "체크하지 않으면 앞으로 새로 생성되는 테이블에만 적용됩니다.": "चेक न करने पर यह केवल भविष्य में नई बनाई गई टेबलों पर लागू होगा।",
    "총": "कुल",
    "총 상금풀(1.5%):": "कुल पुरस्कार पूल (1.5%):",
    "총베팅액:": "कुल बेट राशि:",
    "추가": "जोड़ें",
    "크기(px)": "आकार (px)",
    "클릭 이동 URL(link_url)": "क्लिक गंतव्य URL (link_url)",
    "클릭 이동 링크(URL)": "क्लिक गंतव्य लिंक (URL)",
    "클릭하면 등록 모달": "पंजीकरण विंडो खोलने के लिए क्लिक करें",
    "클릭하면 표시 기준 시간이 해당 날짜로 설정됩니다": "इस दिनांक को प्रदर्शन संदर्भ समय बनाने के लिए क्लिक करें",
    "타이머 없음": "कोई टाइमर नहीं",
    "타이머 타입": "टाइमर प्रकार",
    "타이머(존재유무만)": "टाइमर (केवल मौजूदगी)",
    "타이머는": "टाइमर",
    "타입": "प्रकार",
    "테이블 그룹 목록 조회 실패": "टेबल समूह सूची प्राप्त करने में विफल",
    "테이블 그룹 삭제?\n({displayCode})": "टेबल समूह हटाना है?\n({displayCode})",
    "테이블 그룹 생성 실패": "टेबल समूह बनाने में विफल",
    "테이블 그룹 생성 완료": "टेबल समूह बनाया गया",
    "테이블 그룹 코드 생성 실패": "टेबल समूह कोड बनाने में विफल",
    "테이블 그룹이 없습니다.": "कोई टेबल समूह नहीं है।",
    "테이블 미션 RUN 생성 실패": "टेबल मिशन RUN बनाने में विफल",
    "테이블 미션 RUN 중지 실패": "टेबल मिशन RUN रोकने में विफल",
    "테이블 미션 RUN 중지(그룹 전체 적용)?\n(display_code={displayCode})": "टेबल मिशन RUN रोकना है (पूरे समूह पर लागू)?\n(display_code={displayCode})",
    "테이블 미션 cfg 저장 실패": "टेबल मिशन cfg सेव करने में विफल",
    "테이블 미션 상금 분배(프론트 계산)": "टेबल मिशन पुरस्कार पूल वितरण (frontend गणना)",
    "테이블 미션 상태 조회 실패": "टेबल मिशन स्थिति प्राप्त करने में विफल",
    "테이블 미션 에이전트 분배 비율(agent_share) 입력 (예: 0.2 = 20%)": "टेबल मिशन एजेंट वितरण अनुपात (agent_share) दर्ज करें (उदा.: 0.2 = 20%)",
    "테이블 미션 총 베팅금(target_total_bet)을 입력": "टेबल मिशन की कुल बेट राशि (target_total_bet) दर्ज करें",
    "텍스트": "टेक्स्ट",
    "텍스트 스타일": "टेक्स्ट शैली",
    "파일명": "फ़ाइल नाम",
    "페이지": "पृष्ठ",
    "폴더에 저장되고, DB에는 메타/경로만 저장돼.": "फ़ोल्डर में सेव होता है; DB में केवल मेटा जानकारी/पथ सेव होता है।",
    "표시 기준 시간": "प्रदर्शन संदर्भ समय",
    "표시 순서(order)": "प्रदर्शन क्रम (order)",
    "표시 여부만": "केवल प्रदर्शन स्थिति",
    "프리셋(배경/요소/URL)": "preset (पृष्ठभूमि/तत्व/URL)",
    "플레이어 상금풀(": "खिलाड़ी पुरस्कार पूल (",
    "현재 index 값들을 서버에 저장": "वर्तमान index मान सर्वर पर सेव करें",
    "현재 활성 테이블에도 즉시 적용": "वर्तमान सक्रिय टेबलों पर भी तुरंत लागू करें",
    "활성 RUN이 없습니다.": "कोई सक्रिय RUN नहीं है।"
  },
  "ur": {
    "%) 중 몇 %를 하위에게 분배하시겠습니까?": "%) میں سے کتنے فیصد نچلی سطح کو تقسیم کرنا ہے؟",
    "(password 있음)": "(پاس ورڈ موجود ہے)",
    "(링크 없음)": "(کوئی لنک نہیں)",
    "(본문 없음)": "(کوئی متن نہیں)",
    "(없음)": "(کوئی نہیں)",
    "(여기 클릭하면 새 공지 모달 오픈)": "(نیا اعلان کھولنے کے لیے یہاں کلک کریں)",
    "(이름없음)": "(بے نام)",
    "(자동)": "(خودکار)",
    "* index를 바꾼 뒤": "* index تبدیل کرنے کے بعد",
    "* 무한 모드일 때 UI상 “30일마다 갱신”로 표시용": "* لامحدود موڈ میں UI پر ‘ہر 30 دن بعد تجدید’ دکھانے کے لیے",
    "* 예: 상위 50% 중": "* مثال: اوپری 50% میں سے",
    "* 이 설정은 인포카드 내부 카운트다운 기준입니다. 위 시간 설정은 로비 노출 기간만 제어합니다.": "* یہ ترتیب انفارمیشن کارڈ کے اندر کاؤنٹ ڈاؤن کی بنیاد ہے۔ اوپر والی وقت کی ترتیب صرف لابی میں دکھائی دینے کی مدت کنٹرول کرتی ہے۔",
    "* 이 스타일은 인포카드의 text 요소에만 적용됩니다. 타이머/아이콘은 기존 스타일을 유지합니다.": "* یہ اسٹائل صرف انفارمیشن کارڈ کے text عنصر پر لاگو ہوتا ہے۔ ٹائمر/آئیکن اپنا موجودہ اسٹائل برقرار رکھتے ہیں۔",
    "* 이 시간에 “유효한(display_sets.time)” 그룹만 아래 목록에 표시": "* اس وقت صرف ‘درست (display_sets.time)’ گروپ نیچے فہرست میں دکھائے جاتے ہیں",
    "* 저장은 UTC로 들어가고, 화면은 로컬 시간으로 입력/표시됨": "* محفوظ کرنا UTC میں ہوتا ہے، جبکہ اسکرین پر ان پٹ/ڈسپلے مقامی وقت میں ہوتا ہے",
    "* 필요할 때만 추가하면 됨": "* صرف ضرورت کے وقت شامل کریں",
    "* 현재 기준시간 주변(±15~45일)에 기간(range) 설정된 DisplaySet이 없습니다.": "* موجودہ حوالہ وقت کے آس پاس (±15–45 دن) مدت (range) والا کوئی DisplaySet نہیں ہے۔",
    "+ 공지 작성": "+ اعلان لکھیں",
    "+ 광고 등록": "+ اشتہار شامل کریں",
    "+ 새 공지 작성": "+ نیا اعلان لکھیں",
    "+ 새 광고 등록": "+ نیا اشتہار شامل کریں",
    "+ 아이콘(업로드)": "+ آئیکن (اپ لوڈ)",
    "+ 이미지": "+ تصویر",
    "+ 인포 버튼 추가": "+ انفارمیشن بٹن شامل کریں",
    "+ 인포카드 추가": "+ انفارمیشن کارڈ شامل کریں",
    "+ 타이머(표시여부)": "+ ٹائمر (دکھانا ہے یا نہیں)",
    "- PENDING 는 저장만 되고 노출되지 않음": "- PENDING صرف محفوظ ہوتا ہے اور دکھایا نہیں جاتا",
    "- SCHEDULED 는 startAt 이후 자동 노출": "- SCHEDULED، startAt کے بعد خودکار طور پر دکھایا جاتا ہے",
    "- endAt 이 지나면 자동 만료": "- endAt گزرنے کے بعد خودکار طور پر ختم ہو جاتا ہے",
    "/community/notice/1 또는 https://...": "/community/notice/1 یا https://...",
    "0보다 큰 숫자만 가능": "صرف 0 سے بڑا عدد قابل قبول ہے",
    "DisplaySet 날짜 필터(1일 단위)": "DisplaySet تاریخ فلٹر (1 دن کی اکائی)",
    "Due Date 지정": "Due Date مقرر کریں",
    "Due Date(관리자 로컬 시간)": "Due Date (ایڈمن کا مقامی وقت)",
    "Due Date를 올바른 날짜/시간으로 입력해야 합니다.": "درست Due Date اور وقت درج کریں۔",
    "Due Date를 입력해야 합니다.": "Due Date درج کرنا ضروری ہے۔",
    "RUN 생성: 미션 총 베팅금(target_total_bet) 입력": "RUN بنائیں: مشن کی کل بیٹ رقم (target_total_bet) درج کریں",
    "RUN 생성: 테이블 미션 총 베팅금(target_total_bet) 입력": "RUN بنائیں: ٹیبل مشن کی کل بیٹ رقم (target_total_bet) درج کریں",
    "SB/BB는 0보다 큰 숫자이며 소수점은 최대 2자리까지 입력할 수 있습니다. 예: 0.25 / 0.50": "SB/BB کو 0 سے بڑا عدد ہونا چاہیے اور زیادہ سے زیادہ 2 اعشاری مقامات تک درج کیا جا سکتا ہے۔ مثال: 0.25 / 0.50",
    "USDT TRC20 테스트넷": "USDT TRC20 ٹیسٹ نیٹ",
    "agent_share는 0~1 사이 숫자만 가능 (예: 0.2)": "agent_share صرف 0 اور 1 کے درمیان عدد ہو سکتا ہے (مثال: 0.2)",
    "all / 데스크톱+모바일": "all / ڈیسک ٹاپ + موبائل",
    "desktop / 데스크톱": "desktop / ڈیسک ٹاپ",
    "endAt (종료, 선택)": "endAt (اختتام، اختیاری)",
    "endAt은 startAt보다 늦어야 해.": "endAt، startAt سے بعد کا ہونا چاہیے۔",
    "index(선택)": "index (اختیاری)",
    "message는 빈값이 될 수 없습니다.": "message خالی نہیں ہو سکتا۔",
    "message는 필수입니다.": "message ضروری ہے۔",
    "mobile / 모바일": "mobile / موبائل",
    "reserve_time_utc(표시:로컬)": "reserve_time_utc (ڈسپلے: مقامی)",
    "reserve_time_utc가 지난 waiting들을 running으로 전환": "وہ waiting آئٹمز جن کا reserve_time_utc گزر چکا ہے انہیں running میں تبدیل کریں",
    "startAt (시작)": "startAt (آغاز)",
    "status(선택)": "status (اختیاری)",
    "superadmin 전용 UI (admin-server / DB 저장)": "صرف superadmin UI (admin-server / DB میں محفوظ)",
    "tick 실패": "tick ناکام",
    "{targetId} 삭제하시겠습니까?": "کیا {targetId} حذف کرنا ہے؟",
    "※ 이미지는 admin server 의": "※ تصاویر admin server کے",
    "※ 입력이 없으면 0%로 처리됩니다.": "※ ان پٹ نہ ہونے پر اسے 0% سمجھا جائے گا۔",
    "※ 입력이 없으면 0.00%로 처리됩니다.": "※ ان پٹ نہ ہونے پر اسے 0.00% سمجھا جائے گا۔",
    "※ 현재 저장은 admin-server API를 통해 DB에 반영됨.": "※ موجودہ محفوظ کاری admin-server API کے ذریعے DB میں لاگو ہوتی ہے۔",
    "→ 하위는": "→ نچلی سطح کو",
    "같은 area라도 device/country가 다르면 각각 별도 row로 저장돼.": "area ایک جیسا ہو تب بھی device/country مختلف ہوں تو ہر مجموعہ الگ row میں محفوظ ہوتا ہے۔",
    "갱신 주기(일)": "تجدید کا دورانیہ (دن)",
    "갱신 중": "تجدید جاری ہے",
    "검색: 이름/링크/국가": "تلاش: نام/لنک/ملک",
    "검색: 제목/본문/작성자": "تلاش: عنوان/متن/مصنف",
    "공지 목록 불러오는 중...": "اعلانات کی فہرست لوڈ ہو رہی ہے...",
    "공지 목록을 불러오지 못했어.\n{message}": "اعلانات کی فہرست لوڈ نہیں ہو سکی۔\n{message}",
    "공지 삭제에 실패했어.\n{message}": "اعلان حذف کرنے میں ناکامی۔\n{message}",
    "공지 삭제할까?\n\n- {title}": "کیا یہ اعلان حذف کرنا ہے؟\n\n- {title}",
    "공지 저장에 실패했어.\n{message}": "اعلان محفوظ کرنے میں ناکامی۔\n{message}",
    "공지가 없어. 위에서 새로 작성해줘.": "کوئی اعلان نہیں ہے۔ اوپر سے نیا اعلان بنائیں۔",
    "광고 목록 불러오는 중...": "اشتہارات کی فہرست لوڈ ہو رہی ہے...",
    "광고 목록을 불러오지 못했어.": "اشتہارات کی فہرست لوڈ نہیں ہو سکی۔",
    "광고 삭제에 실패했어.": "اشتہار حذف کرنے میں ناکامی۔",
    "광고 이미지를 업로드해줘.": "اشتہار کی تصویر اپ لوڈ کریں۔",
    "광고 저장에 실패했어.": "اشتہار محفوظ کرنے میں ناکامی۔",
    "광고를 삭제할까?\n\n- {label}": "کیا یہ اشتہار حذف کرنا ہے؟\n\n- {label}",
    "구분": "قسم",
    "국가(country)를 입력해줘. 예: KR / US / JP / ALL": "ملک (country) درج کریں۔ مثال: KR / US / JP / ALL",
    "그룹 미션": "گروپ مشن",
    "그룹 미션 RUN 중지?\nrun_id={runId}": "گروپ مشن RUN روکنا ہے؟\nrun_id={runId}",
    "그룹 미션 설정": "گروپ مشن کی ترتیبات",
    "그룹 미션 시작": "گروپ مشن شروع کریں",
    "그룹 미션 중지 실패 (백엔드에 DELETE /admin/mission/run/:run_id 필요)": "گروپ مشن روکنے میں ناکامی (backend میں DELETE /admin/mission/run/:run_id درکار ہے)",
    "그룹 시간 설정이 올바르지 않습니다.": "گروپ کی وقت کی ترتیب درست نہیں ہے۔",
    "그룹 이름, Small Blind, Big Blind는 필수 입력입니다. SB/BB는 예: 0.25, 0.50처럼 입력할 수 있습니다.": "گروپ کا نام، Small Blind اور Big Blind ضروری ہیں۔ SB/BB کو 0.25، 0.50 جیسے درج کیا جا سکتا ہے۔",
    "그룹은 삭제됐지만 Redis 정리가 실패했습니다. (code={code})": "گروپ حذف ہو گیا، لیکن Redis صفائی ناکام رہی۔ (code={code})",
    "글로벌": "عالمی",
    "내부용 이름(label)": "اندرونی نام (label)",
    "내부용 이름(label)을 입력해줘.": "اندرونی نام (label) درج کریں۔",
    "노출": "نمائش",
    "노출(즉시/기간무관)": "دکھائیں (فوری/مدت سے قطع نظر)",
    "노출중": "دکھایا جا رہا ہے",
    "닉네임": "عرفی نام",
    "대상": "ہدف",
    "데스크톱": "ڈیسک ٹاپ",
    "등록": "رجسٹر کریں",
    "등록된 광고가 없어.": "کوئی اشتہار رجسٹر نہیں ہے۔",
    "등록된 이미지 없음": "کوئی تصویر رجسٹر نہیں ہے",
    "라운지 포인트 %": "لاؤنج پوائنٹ %",
    "라운지 포인트 % (0~100)": "لاؤنج پوائنٹ % (0–100)",
    "라운지 포인트 %는 0~100 사이 숫자이며 소수점은 최대 2자리까지 가능합니다.": "لاؤنج پوائنٹ % کو 0 سے 100 کے درمیان ہونا چاہیے اور زیادہ سے زیادہ 2 اعشاری مقامات تک ہو سکتا ہے۔",
    "레이크백": "ریک بیک",
    "링크:": "لنک:",
    "링크는 http:// 또는 https:// 로 시작해야 해.": "لنک http:// یا https:// سے شروع ہونا چاہیے۔",
    "메모": "نوٹ",
    "메인 영역": "مرکزی حصہ",
    "모바일": "موبائل",
    "무한(infinite) 항목(상시 노출)": "لامحدود (infinite) آئٹم (ہمیشہ دکھائیں)",
    "무한(약 {days}일 단위 갱신)": "لامحدود (تقریباً ہر {days} دن بعد تجدید)",
    "미션 RUN 생성 실패": "مشن RUN بنانے میں ناکامی",
    "미션 cfg 저장 실패": "مشن cfg محفوظ کرنے میں ناکامی",
    "미션 상금 분배(프론트 계산)": "مشن انعامی پول کی تقسیم (frontend حساب)",
    "미션 상태 조회 실패": "مشن کی حالت حاصل کرنے میں ناکامی",
    "미션 총 베팅금(target_total_bet)을 입력": "مشن کی کل بیٹ رقم (target_total_bet) درج کریں",
    "미입력시 자동": "خالی ہونے پر خودکار",
    "배치": "بیچ",
    "백엔드에 종료 API가 있어야 실제 중지됨": "حقیقی طور پر روکنے کے لیے backend پر اختتامی API ضروری ہے",
    "본문을 입력해줘.": "متن درج کریں۔",
    "비밀번호": "پاس ورڈ",
    "비워두면 클릭 이동 없음": "کلک پر کسی جگہ نہ جانے کے لیے خالی چھوڑیں",
    "상단 고정(📌)": "اوپر پن کریں (📌)",
    "상위 에이전트의 수수료(": "اوپری ایجنٹ کا کمیشن (",
    "상태 보기 (테이블 미션 raw)": "حالت دیکھیں (ٹیبل مشن raw ڈیٹا)",
    "새 전광판 등록": "نیا ڈسپلے بورڈ شامل کریں",
    "생성 에러:": "بنانے میں خرابی:",
    "서버로 전송될 preset 문자열(콤마 구분)": "سرور کو بھیجی جانے والی preset سٹرنگ (کاما سے جدا)",
    "수정(설정)": "ترمیم کریں (ترتیبات)",
    "시간 설정": "وقت کی ترتیب",
    "시간 설정이 올바르지 않습니다.": "وقت کی ترتیب درست نہیں ہے۔",
    "시작(생성)": "شروع کریں (بنائیں)",
    "아이디": "آئی ڈی",
    "아이콘 업로드 실패 (서버 업로드 API 확인 필요)": "آئیکن اپ لوڈ ناکام (سرور اپ لوڈ API چیک کریں)",
    "아이콘 파일은 1MB 이하로 올려주세요.": "آئیکن فائل 1MB یا اس سے کم ہونی چاہیے۔",
    "아이콘(로컬 업로드/URL)": "آئیکن (مقامی اپ لوڈ/URL)",
    "아프리카": "افریقہ",
    "업로드 URL을 받지 못했어.": "اپ لوڈ URL موصول نہیں ہوا۔",
    "업로드하면 /uploads/... 로 자동 입력됨 (또는 URL 직접 입력)": "اپ لوڈ کرنے پر /uploads/... خودکار طور پر درج ہو جائے گا (یا براہ راست URL درج کریں)",
    "에이전트": "ایجنٹ",
    "에이전트 분배 비율(agent_share) 입력 (예: 0.2 = 20%)": "ایجنٹ تقسیم کا تناسب (agent_share) درج کریں (مثال: 0.2 = 20%)",
    "에이전트 상금풀(": "ایجنٹ انعامی پول (",
    "예: HOT": "مثال: HOT",
    "예: KR / US / JP / ALL": "مثال: KR / US / JP / ALL",
    "예: NEW YEAR EVENT START!": "مثال: NEW YEAR EVENT START!",
    "예: VIP NLH 1/2": "مثال: VIP NLH 1/2",
    "예: 메인 KR 모바일 상단 배너": "مثال: مرکزی KR موبائل اوپری بینر",
    "예: 오늘만 레이크 0%": "مثال: صرف آج ریک 0%",
    "예: 🔥 12/31 이벤트 진행중": "مثال: 🔥 12/31 ایونٹ جاری ہے",
    "예: 🔧HOT": "مثال: 🔧HOT",
    "예약 tick": "ریزرویشن tick",
    "예약 보류": "ریزرویشن زیر التوا",
    "예약 사용": "ریزرویشن استعمال کریں",
    "예약 상태면 startAt(시작일시)를 넣어줘.": "ریزرو حالت میں startAt (آغاز کی تاریخ/وقت) درج کریں۔",
    "예약 시간이 올바르지 않습니다.": "ریزرویشن کا وقت درست نہیں ہے۔",
    "예약 없음 → 즉시 진행(running)으로 자동 설정됨": "کوئی ریزرویشن نہیں → فوراً running حالت خودکار طور پر مقرر ہو جاتی ہے",
    "예약(reserve_time_utc)": "ریزرویشن (reserve_time_utc)",
    "예약/상태": "ریزرویشن/حالت",
    "예약보류": "ریزرویشن روکی گئی",
    "왼쪽에서 공지를 선택해줘.": "بائیں طرف سے اعلان منتخب کریں۔",
    "왼쪽에서 광고를 선택해줘.": "بائیں طرف سے اشتہار منتخب کریں۔",
    "요소(최대 4개)": "عناصر (زیادہ سے زیادہ 4)",
    "요청 실패 ({status})": "درخواست ناکام ({status})",
    "용량": "حجم",
    "유럽": "یورپ",
    "유효 인포메이션 버튼:": "درست انفارمیشن بٹن:",
    "을 눌러야 서버에 반영됨": "سرور پر لاگو کرنے کے لیے اس پر کلک کرنا ضروری ہے",
    "이동 URL": "منزل URL",
    "이메일": "ای میل",
    "이미 테이블 미션 RUN이 실행 중입니다.\n(run_id={runId})\n재시작(기존 RUN 삭제 후 새로 생성)할까요?": "ٹیبل مشن RUN پہلے سے چل رہا ہے۔\n(run_id={runId})\nکیا موجودہ RUN حذف کر کے نیا بناتے ہوئے دوبارہ شروع کرنا ہے؟",
    "이미지": "تصویر",
    "이미지 넣기": "تصویر شامل کریں",
    "이미지 업로드 실패: {message}": "تصویر اپ لوڈ ناکام: {message}",
    "이미지 업로드중...": "تصویر اپ لوڈ ہو رہی ہے...",
    "이미지 없음": "کوئی تصویر نہیں",
    "이미지 열기": "تصویر کھولیں",
    "이미지 파일만 등록할 수 있어.": "صرف تصویر کی فائل رجسٹر کی جا سکتی ہے۔",
    "이미지 파일만 업로드할 수 있어.": "صرف تصویر کی فائل اپ لوڈ کی جا سکتی ہے۔",
    "이미지(URL)": "تصویر (URL)",
    "이미지는 5MB 이하만 업로드할 수 있어.": "صرف 5MB یا اس سے کم تصاویر اپ لوڈ کی جا سکتی ہیں۔",
    "이미지는 본문 안에 [image-번호] 형태로 표시됨.": "تصاویر متن میں [image-نمبر] کی شکل میں دکھائی جاتی ہیں۔",
    "인포 버튼 시간 설정이 올바르지 않습니다.": "انفارمیشن بٹن کی وقت کی ترتیب درست نہیں ہے۔",
    "인포 버튼 프리셋 수정": "انفارمیشن بٹن preset میں ترمیم کریں",
    "인포 버튼 프리셋 수정 실패": "انفارمیشن بٹن preset کی ترمیم ناکام",
    "인포메이션 버튼(선택)": "انفارمیشن بٹن (اختیاری)",
    "인포버튼 없음": "کوئی انفارمیشن بٹن نہیں",
    "인포버튼 프리셋 수정": "انفارمیشن بٹن preset میں ترمیم کریں",
    "인포버튼 프리셋 수정 실패": "انفارمیشن بٹن preset کی ترمیم ناکام",
    "인포카드 추가": "انفارمیشن کارڈ شامل کریں",
    "인포카드 추가 실패": "انفارمیشن کارڈ شامل کرنے میں ناکامی",
    "인포카드 타이머": "انفارمیشن کارڈ ٹائمر",
    "임시": "عارضی",
    "임시저장": "ڈرافٹ محفوظ کریں",
    "자산": "اثاثے",
    "작성자": "مصنف",
    "잠금 비밀번호": "لاک پاس ورڈ",
    "재시작": "دوبارہ شروع کریں",
    "저장 시 실제 이미지 URL 토큰으로 자동 변환됨.": "محفوظ کرتے وقت یہ خودکار طور پر حقیقی تصویر URL ٹوکن میں تبدیل ہو جاتا ہے۔",
    "저장됩니다. 기준 시간은 위 인포카드 타이머 설정(timerMode/timerEndUtc)을 사용합니다.": "محفوظ کیا جائے گا۔ حوالہ وقت اوپر کی انفارمیشن کارڈ ٹائمر ترتیب (timerMode/timerEndUtc) استعمال کرتا ہے۔",
    "저장중...": "محفوظ ہو رہا ہے...",
    "전광판": "ڈسپلے بورڈ",
    "전광판 관리": "ڈسپلے بورڈ کا انتظام",
    "전광판 등록 실패": "ڈسپلے بورڈ رجسٹریشن ناکام",
    "전광판 목록 조회 실패": "ڈسپلے بورڈ کی فہرست حاصل کرنے میں ناکامی",
    "전광판 삭제 실패": "ڈسپلے بورڈ حذف کرنے میں ناکامی",
    "전광판 삭제?\n(id={id})": "ڈسپلے بورڈ حذف کرنا ہے؟\n(id={id})",
    "전광판 수정 실패": "ڈسپلے بورڈ میں ترمیم ناکام",
    "정렬 변경에 실패했어.": "ترتیب بدلنے میں ناکامی۔",
    "정렬 저장": "ترتیب محفوظ کریں",
    "정렬 저장 실패": "ترتیب محفوظ کرنے میں ناکامی",
    "정렬 화살표는 같은 area/device/country 묶음 안에서만 동작해.": "ترتیب کے تیر صرف ایک ہی area/device/country گروپ کے اندر کام کرتے ہیں۔",
    "정상": "معمول",
    "제목을 입력해줘.": "عنوان درج کریں۔",
    "조회": "دیکھیں",
    "줄바꿈 그대로 표시됨.": "لائن بریک جوں کے توں دکھائے جاتے ہیں۔",
    "중동": "مشرق وسطیٰ",
    "중앙아시아": "وسطی ایشیا",
    "중지(삭제)": "روکیں (حذف کریں)",
    "지금": "ابھی",
    "지급 실패": "ادائیگی ناکام",
    "직속": "براہ راست",
    "차감 실패": "کٹوتی ناکام",
    "체크하지 않으면 앞으로 새로 생성되는 테이블에만 적용됩니다.": "اگر نشان نہ لگایا جائے تو یہ صرف مستقبل میں بننے والی نئی ٹیبلز پر لاگو ہوگا۔",
    "총": "کل",
    "총 상금풀(1.5%):": "کل انعامی پول (1.5%):",
    "총베팅액:": "کل بیٹ رقم:",
    "추가": "شامل کریں",
    "크기(px)": "حجم (px)",
    "클릭 이동 URL(link_url)": "کلک منزل URL (link_url)",
    "클릭 이동 링크(URL)": "کلک منزل لنک (URL)",
    "클릭하면 등록 모달": "رجسٹریشن ونڈو کھولنے کے لیے کلک کریں",
    "클릭하면 표시 기준 시간이 해당 날짜로 설정됩니다": "اس تاریخ کو ڈسپلے حوالہ وقت بنانے کے لیے کلک کریں",
    "타이머 없음": "کوئی ٹائمر نہیں",
    "타이머 타입": "ٹائمر کی قسم",
    "타이머(존재유무만)": "ٹائمر (صرف موجودگی)",
    "타이머는": "ٹائمر",
    "타입": "قسم",
    "테이블 그룹 목록 조회 실패": "ٹیبل گروپ کی فہرست حاصل کرنے میں ناکامی",
    "테이블 그룹 삭제?\n({displayCode})": "ٹیبل گروپ حذف کرنا ہے؟\n({displayCode})",
    "테이블 그룹 생성 실패": "ٹیبل گروپ بنانے میں ناکامی",
    "테이블 그룹 생성 완료": "ٹیبل گروپ بنا دیا گیا",
    "테이블 그룹 코드 생성 실패": "ٹیبل گروپ کوڈ بنانے میں ناکامی",
    "테이블 그룹이 없습니다.": "کوئی ٹیبل گروپ نہیں ہے۔",
    "테이블 미션 RUN 생성 실패": "ٹیبل مشن RUN بنانے میں ناکامی",
    "테이블 미션 RUN 중지 실패": "ٹیبل مشن RUN روکنے میں ناکامی",
    "테이블 미션 RUN 중지(그룹 전체 적용)?\n(display_code={displayCode})": "ٹیبل مشن RUN روکنا ہے (پورے گروپ پر لاگو)؟\n(display_code={displayCode})",
    "테이블 미션 cfg 저장 실패": "ٹیبل مشن cfg محفوظ کرنے میں ناکامی",
    "테이블 미션 상금 분배(프론트 계산)": "ٹیبل مشن انعامی پول کی تقسیم (frontend حساب)",
    "테이블 미션 상태 조회 실패": "ٹیبل مشن کی حالت حاصل کرنے میں ناکامی",
    "테이블 미션 에이전트 분배 비율(agent_share) 입력 (예: 0.2 = 20%)": "ٹیبل مشن ایجنٹ تقسیم کا تناسب (agent_share) درج کریں (مثال: 0.2 = 20%)",
    "테이블 미션 총 베팅금(target_total_bet)을 입력": "ٹیبل مشن کی کل بیٹ رقم (target_total_bet) درج کریں",
    "텍스트": "متن",
    "텍스트 스타일": "متن کا اسٹائل",
    "파일명": "فائل کا نام",
    "페이지": "صفحہ",
    "폴더에 저장되고, DB에는 메타/경로만 저장돼.": "فولڈر میں محفوظ ہوتا ہے؛ DB میں صرف میٹا معلومات/راستہ محفوظ ہوتا ہے۔",
    "표시 기준 시간": "ڈسپلے حوالہ وقت",
    "표시 순서(order)": "ڈسپلے ترتیب (order)",
    "표시 여부만": "صرف نمائش کی حالت",
    "프리셋(배경/요소/URL)": "preset (پس منظر/عناصر/URL)",
    "플레이어 상금풀(": "کھلاڑی انعامی پول (",
    "현재 index 값들을 서버에 저장": "موجودہ index قدریں سرور پر محفوظ کریں",
    "현재 활성 테이블에도 즉시 적용": "موجودہ فعال ٹیبلز پر بھی فوراً لاگو کریں",
    "활성 RUN이 없습니다.": "کوئی فعال RUN نہیں ہے۔"
  }
};

// Common international abbreviations are expanded where the local UI convention is clearer.
Object.assign(legacyCompletion.ru, { '아이디': 'Идентификатор', '이메일': 'Электронная почта' });
Object.assign(legacyCompletion.zh, { '아이디': '用户编号' });
Object.assign(legacyCompletion.vi, { '아이디': 'Mã định danh', '이메일': 'Thư điện tử' });
Object.assign(legacyCompletion.th, { '아이디': 'รหัสผู้ใช้' });
Object.assign(legacyCompletion.ja, { '아이디': 'ユーザーID' });
Object.assign(legacyCompletion.hi, { '아이디': 'उपयोगकर्ता आईडी' });
Object.assign(legacyCompletion.ur, { '아이디': 'صارف آئی ڈی' });


export default legacyCompletion;
